import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { 
  Users, FileText, CreditCard, Building2, Smartphone, Bell, AlertTriangle, 
  BarChart3, Settings, Send, Mail, UserCheck, Newspaper, TrendingUp, 
  TrendingDown, DollarSign, Wallet, Shield, CheckCircle, XCircle, 
  Eye, Edit, Trash2, Plus, Download, Upload, RefreshCw, Search,
  ChevronDown, ChevronUp, Clock, Calendar, Activity, PieChart,
  Landmark, Bitcoin, Globe, MessageSquare, HelpCircle, Lock, Unlock,
  HardDrive, Database, Save, RotateCcw
} from 'lucide-react';
import ManagerManagement from './ManagerManagement';
import OpenPositionsManagement from './OpenPositionsManagement';
// Faz 2 Paket 3 — ManipulatePanel silindi (eski matematik aracı)
import DiscoveryPanel from './DiscoveryPanel';
import AdminLiveChat from '../components/AdminLiveChat';
import AdminNews from '../components/AdminNews';
import UserDetailManagement from '../components/UserDetailManagement';
import AuditLogViewer from '../components/AuditLogViewer';
import LoginDesignGallery from '../components/LoginDesignGallery';
import CryptoSettings from '../components/CryptoSettings';

// Runtime detection - works in both localhost and production
const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8001/api' 
  : '/api';

// BACKEND_URL for asset URLs - use current origin in production
const BACKEND_URL = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8001' 
  : (typeof window !== 'undefined' ? window.location.origin : '');

// Helper function to get full URL for assets
const getFullAssetUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  // For relative URLs, prepend the origin
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${url}`;
};

const CATEGORIES = ['ENDEKSLER', 'EMTIA', 'EXCHANGE', 'KRIPTO', 'BORSA_ISTANBUL', 'STOCKS'];

function AdminPanelNew({ user, setUser }) {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('traders');
  const [users, setUsers] = useState([]);
  const [assets, setAssets] = useState([]);
  const [allPositions, setAllPositions] = useState([]);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [depositRequests, setDepositRequests] = useState([]);
  const [withdrawalRequests, setWithdrawalRequests] = useState([]);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [marginCallUsers, setMarginCallUsers] = useState([]);
  const [dashboardStats, setDashboardStats] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false); // Kullanıcı listesi için ayrı loading
  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [balanceAdjustment, setBalanceAdjustment] = useState({ user_id: '', amount: '', reason: '' });
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [userDetailData, setUserDetailData] = useState(null);
  const [userPositions, setUserPositions] = useState([]);
  const [userTransactions, setUserTransactions] = useState([]);
  const [newPassword, setNewPassword] = useState('');
  const [showEditAssetModal, setShowEditAssetModal] = useState(false);
  const [editingAsset, setEditingAsset] = useState(null);
  const [syncingPrices, setSyncingPrices] = useState(false);
  const [bulkUpdating, setBulkUpdating] = useState(false);
  const [selectedAssetCategory, setSelectedAssetCategory] = useState('BIST_100');
  
  // Create User Modal
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  
  // Delete User State
  const [deleteConfirmUser, setDeleteConfirmUser] = useState(null); // {id, email} - silme onayı için
  
  // Toplu Silme State
  const [selectedUsers, setSelectedUsers] = useState([]); // Seçilen kullanıcı ID'leri
  const [showBulkDeleteConfirm, setShowBulkDeleteConfirm] = useState(false); // Toplu silme onay durumu
  
  // Debug: Delete modal state
  useEffect(() => {
    console.log('🗑️ deleteConfirmUser state changed:', deleteConfirmUser);
  }, [deleteConfirmUser]);
  
  // Debug: Modal state change logger
  useEffect(() => {
    console.log('📦 showCreateUserModal state changed:', showCreateUserModal);
  }, [showCreateUserModal]);
  
  const [createUserForm, setCreateUserForm] = useState({
    email: '',
    password: '',
    name: '',
    surname: '',
    tc_no: '',
    phone: '',
    account_type: 'STANDART',
    balance: 0,
    credit: 0
  });
  
  // API Settings
  const [apiKey, setApiKey] = useState('');
  const [apiSettings, setApiSettings] = useState(null);
  
  // Support Tickets
  const [supportTickets, setSupportTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketMessages, setTicketMessages] = useState([]);
  const [adminReply, setAdminReply] = useState('');
  
  // Documents
  const [documents, setDocuments] = useState([]);
  
  // Brokers
  const [brokers, setBrokers] = useState([]);
  const [showBrokerModal, setShowBrokerModal] = useState(false);
  const [editingBroker, setEditingBroker] = useState(null);
  const [brokerForm, setBrokerForm] = useState({
    name: '',
    logo_url: '',
    color: '#003087',
    spk_doc_url: ''
  });
  
  // Landing Page Editor
  const [showLandingPageEditor, setShowLandingPageEditor] = useState(false);
  const [editingLandingPage, setEditingLandingPage] = useState(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [landingPageConfig, setLandingPageConfig] = useState({
    hero_title: '',
    hero_subtitle: '',
    hero_button_text: '',
    sections: []
  });
  
  // IBAN Settings - Çoklu Banka Sistemi
  const [ibanSettings, setIbanSettings] = useState({
    bank_name: 'GARANTİ BANKASI',
    account_holder: 'TRADING PLATFORM A.Ş.',
    iban: 'TR12 3456 7890 1234 5678 9012 34'
  });
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const fileInputRef = useRef(null);
  
  // Banka Hesapları (Yeni Sistem)
  const [bankAccounts, setBankAccounts] = useState([]);
  const [availableBanks, setAvailableBanks] = useState([]);
  const [showAddBankModal, setShowAddBankModal] = useState(false);
  const [newBankAccount, setNewBankAccount] = useState({
    bank_code: '',
    account_holder: '',
    iban: ''
  });
  
  // Live Chat Notifications
  const [liveChatUnreadCount, setLiveChatUnreadCount] = useState(0);
  const audioRef = useRef(null);
  const liveChatPollingRef = useRef(null);
  
  // News
  const [newsList, setNewsList] = useState([]);
  const [newsForm, setNewsForm] = useState({
    title: '',
    content: '',
    category: 'GENEL',
    image_url: '',
    source: '',
    published: true
  });
  const [editingNewsId, setEditingNewsId] = useState(null);
  
  // Telegram Settings
  const [telegramSettings, setTelegramSettings] = useState({
    bot_token: '',
    chat_id: '',
    whatsapp_number: '',
    whatsapp_enabled: false
  });
  
  // Backup/Restore
  const [backupLoading, setBackupLoading] = useState(false);
  const [restoreLoading, setRestoreLoading] = useState(false);
  const [backupResult, setBackupResult] = useState(null);
  const backupFileInputRef = useRef(null);
  
  // Live Support
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [replyMessage, setReplyMessage] = useState('');
  const adminMessagesEndRef = useRef(null);

  // Notifications
  const [notificationForm, setNotificationForm] = useState({
    title: '',
    message: '',
    type: 'info',
    user_id: null
  });
  const [sendingNotification, setSendingNotification] = useState(false);
  const [notificationResult, setNotificationResult] = useState(null); // { success: true/false, message: '...' }

  // Email state'leri
  const [emailForm, setEmailForm] = useState({
    subject: '',
    message: '',
    selectedUser: 'all'
  });
  const [sendingEmail, setSendingEmail] = useState(false);
  const [emailResult, setEmailResult] = useState(null);
  const [autoWelcomeEmailEnabled, setAutoWelcomeEmailEnabled] = useState(true);

  // Site içi modal'lar (alert/confirm yerine)
  const [alertModal, setAlertModal] = useState({ show: false, message: '', type: 'info' }); // type: success, error, info
  const [confirmModal, setConfirmModal] = useState({ show: false, message: '', onConfirm: null });

  // Alert helper
  const showAlert = (message, type = 'info') => setAlertModal({ show: true, message, type });
  
  // Confirm helper
  const showConfirm = (message, onConfirm) => setConfirmModal({ show: true, message, onConfirm });

  // Form states
  const [newAsset, setNewAsset] = useState({
    symbol: '',
    name: '',
    category: 'BORSA_ISTANBUL',
    current_price: '',
    is_mock: true
  });

  const token = localStorage.getItem('token');
  const axiosConfig = {
    headers: { 'Authorization': `Bearer ${token}` }
  };

  // Global Live Chat Notifications
  useEffect(() => {
    // Initialize audio
    const notificationSound = "data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBTGH0fPTgjMGHm7A7+OZSA0PVKzn77BdGAg+ltzy0H4pBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBSl+zPLaizsIGGS57OihUBELTqXh8bllHAU2jdXzz3wqBQ==";
    audioRef.current = new Audio(notificationSound);
    
    const checkLiveChatNotifications = async () => {
      try {
        const response = await axios.get(`${API}/admin/live-chats/unread-count`, axiosConfig);
        const newCount = response.data.unread_count || 0;
        
        // Play sound if unread count increased
        if (newCount > liveChatUnreadCount && liveChatUnreadCount > 0) {
          audioRef.current?.play().catch(e => console.log('Audio play failed:', e));
        }
        
        setLiveChatUnreadCount(newCount);
      } catch (err) {
        console.error('Error checking live chat notifications:', err);
      }
    };
    
    // Initial check
    checkLiveChatNotifications();
    
    // Poll every 3 seconds
    liveChatPollingRef.current = setInterval(checkLiveChatNotifications, 3000);
    
    return () => {
      if (liveChatPollingRef.current) {
        clearInterval(liveChatPollingRef.current);
      }
    };
  }, [liveChatUnreadCount]);

  useEffect(() => {
    fetchDashboardStats();
    // Sadece gerekli sekme için veri çek - performans için
    if (activeTab === 'traders' && users.length === 0) fetchUsers();
    if (activeTab === 'assets') fetchAssets();
    if (activeTab === 'positions') fetchAllPositions();
    if (activeTab === 'orders') fetchPendingOrders();
    if (activeTab === 'documents') fetchDocuments();
    if (activeTab === 'deposits') fetchDepositRequests();
    if (activeTab === 'withdrawals') fetchWithdrawalRequests();
    if (activeTab === 'telegram') fetchTelegramSettings();
    if (activeTab === 'support-tickets') {
      fetchConversations();
      fetchSupportTickets();
      // Auto-refresh conversations every 2 seconds
      const interval = setInterval(() => {
        fetchConversations();
        fetchSupportTickets();
      }, 2000);
      return () => clearInterval(interval);
    }
    if (activeTab === 'api-settings') fetchAPISettings();
    if (activeTab === 'online') fetchOnlineUsers();
    if (activeTab === 'margin') fetchMarginCallUsers();
    if (activeTab === 'brokers') fetchBrokers();
    if (activeTab === 'settings') {
      fetchIBANSettings();
      fetchBankAccounts();
      fetchAvailableBanks();
    }
    if (activeTab === 'email') fetchEmailSettings();
  }, [activeTab]);

  const fetchEmailSettings = async () => {
    try {
      const response = await axios.get(`${API}/admin/email-settings`, axiosConfig);
      setAutoWelcomeEmailEnabled(response.data.auto_welcome_email_enabled !== false);
    } catch (err) {
      console.error('Email settings fetch error:', err);
    }
  };

  const toggleAutoWelcomeEmail = async () => {
    try {
      const newValue = !autoWelcomeEmailEnabled;
      await axios.put(`${API}/admin/email-settings`, {
        auto_welcome_email_enabled: newValue
      }, axiosConfig);
      setAutoWelcomeEmailEnabled(newValue);
      showAlert(newValue ? 'Otomatik hoş geldin e-postası aktif!' : 'Otomatik hoş geldin e-postası kapatıldı!', newValue ? 'success' : 'info');
    } catch (err) {
      showAlert('Ayar güncellenemedi: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };

  // ==================== YEDEKLEME FONKSİYONLARI ====================
  
  const handleCreateBackup = async () => {
    setBackupLoading(true);
    setBackupResult(null);
    try {
      const response = await axios.get(`${API}/admin/backup/full`, axiosConfig);
      const backupData = response.data;
      
      // JSON dosyası olarak indir
      const dataStr = JSON.stringify(backupData, null, 2);
      const dataBlob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      const date = new Date().toISOString().split('T')[0];
      link.download = `trading_backup_${date}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      // İstatistikleri göster
      const stats = {
        users: backupData.users?.length || 0,
        positions: backupData.positions?.length || 0,
        transactions: backupData.transactions?.length || 0,
        deposits: backupData.deposit_requests?.length || 0,
        withdrawals: backupData.withdrawal_requests?.length || 0,
      };
      
      setBackupResult({
        success: true,
        message: `Yedek başarıyla oluşturuldu! (${stats.users} kullanıcı, ${stats.transactions} işlem, ${stats.deposits} yatırım, ${stats.withdrawals} çekim)`,
        stats
      });
      
      showAlert('Yedek dosyası indirildi!', 'success');
    } catch (err) {
      setBackupResult({
        success: false,
        message: 'Yedekleme hatası: ' + (err.response?.data?.detail || err.message)
      });
      showAlert('Yedekleme hatası: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setBackupLoading(false);
    }
  };
  
  const handleRestoreBackup = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    
    setRestoreLoading(true);
    setBackupResult(null);
    
    try {
      const fileContent = await file.text();
      const backupData = JSON.parse(fileContent);
      
      // Yedek formatını kontrol et
      if (!backupData.backup_version) {
        throw new Error('Geçersiz yedek dosyası formatı');
      }
      
      // Onay al
      const confirmMessage = `Bu yedek ${backupData.backup_date} tarihinde ${backupData.backup_by} tarafından oluşturulmuş.\n\nGeri yüklemek istediğinize emin misiniz?\n\n⚠️ UYARI: Mevcut veriler üzerine yazılacak!`;
      if (!window.confirm(confirmMessage)) {
        setRestoreLoading(false);
        return;
      }
      
      const response = await axios.post(`${API}/admin/backup/restore`, backupData, axiosConfig);
      
      setBackupResult({
        success: true,
        message: `Geri yükleme tamamlandı! ${JSON.stringify(response.data.restored_counts)}`,
        restored: response.data.restored_counts
      });
      
      showAlert('Yedek başarıyla geri yüklendi!', 'success');
      
      // Sayfayı yenile
      setTimeout(() => window.location.reload(), 2000);
      
    } catch (err) {
      setBackupResult({
        success: false,
        message: 'Geri yükleme hatası: ' + (err.response?.data?.detail || err.message)
      });
      showAlert('Geri yükleme hatası: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setRestoreLoading(false);
      // Input'u temizle
      if (backupFileInputRef.current) {
        backupFileInputRef.current.value = '';
      }
    }
  };

  const fetchDashboardStats = async () => {
    try {
      const response = await axios.get(`${API}/admin/dashboard-stats`, axiosConfig);
      setDashboardStats(response.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const fetchUsers = async () => {
    setUsersLoading(true);
    try {
      const response = await axios.get(`${API}/admin/users`, axiosConfig);
      // Yeni kullanıcılar üstte - created_at'e göre sırala (en yeni en üstte)
      const sortedUsers = response.data.sort((a, b) => {
        const dateA = new Date(a.created_at || 0);
        const dateB = new Date(b.created_at || 0);
        return dateB - dateA; // Descending (en yeni üstte)
      });
      setUsers(sortedUsers);
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setUsersLoading(false);
    }
  };

  const handleCreateUser = async () => {
    try {
      if (!createUserForm.email || !createUserForm.password) {
        showAlert('Email ve şifre zorunludur', 'error');
        return;
      }
      
      const response = await axios.post(`${API}/admin/users/create`, createUserForm, axiosConfig);
      showAlert('Kullanıcı başarıyla oluşturuldu!', 'success');
      setShowCreateUserModal(false);
      setCreateUserForm({
        email: '',
        password: '',
        name: '',
        surname: '',
        tc_no: '',
        phone: '',
        account_type: 'STANDART',
        balance: 0,
        credit: 0
      });
      fetchUsers();
    } catch (err) {
      showAlert(err.response?.data?.detail || 'Kullanıcı oluşturulamadı', 'error');
    }
  };

  // Kullanıcı Yedekleme (Export)
  const handleExportUsers = async () => {
    try {
      showAlert('Kullanıcılar indiriliyor...', 'info');
      const response = await axios.get(`${API}/admin/users/export`, axiosConfig);
      
      // Create and download JSON file
      const dataStr = JSON.stringify(response.data, null, 2);
      const blob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `kullanicilar_yedek_${new Date().toISOString().slice(0,10)}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      showAlert(`${response.data.total_users} kullanıcı başarıyla indirildi!`, 'success');
    } catch (err) {
      showAlert('Yedekleme hatası: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };

  // Kullanıcı Geri Yükleme (Import)
  const handleImportUsers = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    try {
      showAlert('Kullanıcılar yükleniyor...', 'info');
      
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = JSON.parse(e.target.result);
          const response = await axios.post(`${API}/admin/users/import`, data, axiosConfig);
          
          let message = `Yükleme tamamlandı!\n\nYeni eklenen: ${response.data.imported}\nGüncellenen: ${response.data.updated || 0}`;
          
          if (response.data.errors && response.data.errors.length > 0) {
            message += `\n\nHatalar:\n${response.data.errors.slice(0, 3).join('\n')}`;
          }
          
          message += `\n\nNot: ${response.data.note || 'İşlem tamamlandı'}`;
          
          showAlert(message, 'success');
          fetchUsers();
        } catch (err) {
          showAlert('Yükleme hatası: ' + (err.response?.data?.detail || err.message), 'error');
        }
      };
      reader.readAsText(file);
    } catch (err) {
      showAlert('Dosya okuma hatası', 'error');
    }
    
    // Reset file input
    event.target.value = '';
  };

  const fetchUserDetail = async (userId) => {
    try {
      // Önce eski veriyi temizle
      setUserDetailData(null);
      setLoading(true);
      
      console.log('📊 Fetching user detail for ID:', userId);
      const userResponse = await axios.get(`${API}/admin/users/${userId}`, axiosConfig);
      console.log('📊 User detail response:', userResponse.data?.id, userResponse.data?.email);
      
      // Dönen verinin doğru kullanıcı olduğunu kontrol et
      if (userResponse.data && userResponse.data.id === userId) {
        setUserDetailData(userResponse.data);
        setShowUserDetailModal(true);
      } else {
        console.error(' User ID mismatch! Requested:', userId, 'Received:', userResponse.data?.id);
        showAlert('Kullanıcı verisi uyuşmuyor, lütfen tekrar deneyin', 'error');
      }
      setLoading(false);
    } catch (err) {
      console.error('Error fetching user detail:', err);
      showAlert('Kullanıcı detayları alınamadı', 'error');
      setLoading(false);
    }
  };

  const handleCloseUserDetail = () => {
    setShowUserDetailModal(false);
    setUserDetailData(null);
    fetchUsers(); // Refresh user list
    fetchDashboardStats(); // Refresh stats
  };

  const updateUserPassword = async () => {
    if (!newPassword || newPassword.length < 6) {
      showAlert('Şifre en az 6 karakter olmalı', 'error');
      return;
    }
    
    try {
      await axios.put(`${API}/admin/users/${userDetailData.id}/password`, 
        { new_password: newPassword }, 
        axiosConfig
      );
      showAlert('Şifre başarıyla güncellendi!', 'success');
      setNewPassword('');
    } catch (err) {
      showAlert('Şifre güncellenemedi: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };

  const fetchAssets = async () => {
    try {
      const response = await axios.get(`${API}/assets`);
      setAssets(response.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  // Toplu Fiyat Güncelleme
  const handleSyncPrices = async (category = 'BIST_100') => {
    if (syncingPrices) return;
    
    try {
      setSyncingPrices(true);
      showAlert(`${category} fiyatları güncelleniyor...`, 'info');
      
      const response = await axios.post(`${API}/admin/sync-prices`, 
        { category }, 
        axiosConfig
      );
      
      const data = response.data;
      showAlert(`${data.updated} hisse güncellendi`, 'success');
      
      // Varlıkları yenile
      fetchAssets();
    } catch (err) {
      showAlert('Fiyat güncelleme hatası: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setSyncingPrices(false);
    }
  };

  // API'den Toplu Fiyat Güncelleme (Fiyat Güncelleme)
  const handleBulkUpdateFromAPI = async (categories = []) => {
    if (bulkUpdating) return;
    
    try {
      setBulkUpdating(true);
      const categoryText = categories.length === 0 ? 'TÜM KATEGORİLER' : categories.join(', ');
      showAlert(`${categoryText} API'den güncelleniyor... (Bu işlem biraz sürebilir)`, 'info');
      
      const response = await axios.post(`${API}/admin/bulk-update-all-prices`, 
        { categories: categories.length === 0 ? [] : categories }, 
        { ...axiosConfig, timeout: 120000 } // 2 dakika timeout
      );
      
      const data = response.data;
      const results = data.results;
      showAlert(`Toplu güncelleme tamamlandı: ${results.total_updated} başarılı, ${results.total_failed} başarısız`, 'success');
      
      // Varlıkları yenile
      fetchAssets();
    } catch (err) {
      showAlert('API güncelleme hatası: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setBulkUpdating(false);
    }
  };

  const fetchAllPositions = async () => {
    try {
      const response = await axios.get(`${API}/admin/all-positions`, axiosConfig);
      setAllPositions(response.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const fetchPendingOrders = async () => {
    try {
      const response = await axios.get(`${API}/admin/pending-orders`, axiosConfig);
      setPendingOrders(response.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const fetchDepositRequests = async () => {
    try {
      const response = await axios.get(`${API}/admin/deposit-requests`, axiosConfig);
      setDepositRequests(response.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const fetchWithdrawalRequests = async () => {
    try {
      const response = await axios.get(`${API}/admin/withdrawals`, axiosConfig);
      setWithdrawalRequests(response.data.withdrawals || []);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const fetchOnlineUsers = async () => {
    try {
      const response = await axios.get(`${API}/admin/online-users`, axiosConfig);
      setOnlineUsers(response.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const fetchMarginCallUsers = async () => {
    try {
      const response = await axios.get(`${API}/admin/margin-call-users`, axiosConfig);
      setMarginCallUsers(response.data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const handleApproveDeposit = async (requestId) => {
    try {
      await axios.post(`${API}/admin/deposit-requests/${requestId}/approve`, {}, axiosConfig);
      showAlert('Yatırım onaylandı!', 'success');
      fetchDepositRequests();
      fetchDashboardStats();
    } catch (err) {
      showAlert(err.response?.data?.detail || 'Hata oluştu', 'error');
    }
  };

  const handleRejectDeposit = async (requestId) => {
    try {
      await axios.post(`${API}/admin/deposit-requests/${requestId}/reject`, {}, axiosConfig);
      showAlert('Yatırım reddedildi', 'info');
      fetchDepositRequests();
    } catch (err) {
      showAlert('Hata oluştu', 'error');
    }
  };

  const handleApproveWithdrawal = async (requestId) => {
    try {
      await axios.post(`${API}/admin/withdrawals/${requestId}/review?status=APPROVED`, {}, axiosConfig);
      showAlert('Çekim onaylandı!', 'success');
      fetchWithdrawalRequests();
      fetchUsers();
    } catch (err) {
      showAlert(err.response?.data?.detail || 'Hata oluştu', 'error');
    }
  };

  const handleRejectWithdrawal = async (requestId) => {
    try {
      await axios.post(`${API}/admin/withdrawals/${requestId}/review?status=REJECTED`, {}, axiosConfig);
      showAlert('Çekim reddedildi', 'info');
      fetchWithdrawalRequests();
    } catch (err) {
      showAlert('Hata oluştu', 'error');
    }
  };

  const handleCreateAsset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/assets`, {
        ...newAsset,
        current_price: parseFloat(newAsset.current_price)
      }, axiosConfig);
      
      showAlert('Varlık başarıyla eklendi!', 'success');
      setNewAsset({
        symbol: '',
        name: '',
        category: 'BORSA_ISTANBUL',
        current_price: '',
        is_mock: true
      });
      fetchAssets();
    } catch (err) {
      showAlert(err.response?.data?.detail || 'Varlık eklenirken hata oluştu', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAsset = async (assetId) => {
    
    try {
      await axios.delete(`${API}/assets/${assetId}`, axiosConfig);
      showAlert('Varlık silindi!', 'success');
      fetchAssets();
    } catch (err) {
      showAlert('Varlık silinirken hata oluştu', 'error');
    }
  };

  const handleOpenEditAsset = (asset) => {
    setEditingAsset({
      ...asset,
      current_price: asset.current_price.toString(),
      change_percent: asset.change_percent ? asset.change_percent.toString() : '0'
    });
    setShowEditAssetModal(true);
  };

  const handleUpdateAsset = async () => {
    console.log('handleUpdateAsset called', editingAsset);
    if (!editingAsset.current_price || parseFloat(editingAsset.current_price) <= 0) {
      showAlert('Geçerli bir fiyat girin', 'error');
      return;
    }

    try {
      const updateData = {
        symbol: editingAsset.symbol,
        name: editingAsset.name,
        category: editingAsset.category,
        current_price: parseFloat(editingAsset.current_price),
        change_percent: parseFloat(editingAsset.change_percent || 0)
      };
      
      console.log('Sending update:', updateData);
      const response = await axios.put(`${API}/assets/${editingAsset.id}`, updateData, axiosConfig);
      console.log('Update response:', response.data);

      showAlert('Varlık güncellendi!', 'success');
      setShowEditAssetModal(false);
      fetchAssets();
    } catch (err) {
      console.error('Update error:', err);
      showAlert('Güncelleme hatası: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };
  const handleAdjustBalance = async () => {
    if (!balanceAdjustment.user_id || !balanceAdjustment.amount) {
      showAlert('Lütfen kullanıcı seçin ve miktar girin', 'error');
      return;
    }
    
    try {
      setLoading(true);
      await axios.post(`${API}/admin/adjust-balance`, {
        user_id: balanceAdjustment.user_id,
        amount: parseFloat(balanceAdjustment.amount),
        reason: balanceAdjustment.reason || 'Admin ayarlaması'
      }, axiosConfig);
      
      showAlert('Bakiye başarıyla güncellendi!', 'success');
      setShowBalanceModal(false);
      setBalanceAdjustment({ user_id: '', amount: '', reason: '' });
      fetchUsers(); // Refresh user list
      
    } catch (err) {
      showAlert('Bakiye güncellenemedi: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  const openBalanceModal = (userId, userEmail) => {
    setBalanceAdjustment({ user_id: userId, amount: '', reason: `${userEmail} bakiye ayarlaması` });
    setShowBalanceModal(true);
  };

  const handleChangeAccountType = async (userId, newAccountType) => {
    try {
      setLoading(true);
      await axios.post(`${API}/admin/change-account-type`, null, {
        params: {
          user_id: userId,
          account_type: newAccountType
        },
        ...axiosConfig
      });
      
      showAlert('Hesap tipi başarıyla değiştirildi!', 'success');
      
      // Refresh to get updated data
      await fetchUsers();
      
    } catch (err) {
      showAlert('Hesap tipi değiştirilemedi: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleBanToggle = async (userId, userEmail, isBanned) => {
    const action = isBanned ? 'banını kaldırmak' : 'banlamak';
    const confirmMsg = `${userEmail} kullanıcısını ${action} istediğinize emin misiniz?`;
    
    
    try {
      setLoading(true);
      const endpoint = isBanned ? 'unban' : 'ban';
      await axios.post(`${API}/admin/users/${userId}/${endpoint}`, {}, axiosConfig);
      
      showAlert(isBanned ? 'Kullanıcı banı kaldırıldı!' : 'Kullanıcı başarıyla banlandı!', 'success');
      
      // Refresh to get updated data
      await fetchUsers();
      
    } catch (err) {
      showAlert('İşlem başarısız: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Kullanıcı Silme Fonksiyonu
  const handleDeleteUser = async (userId, userEmail) => {
    try {
      setLoading(true);
      await axios.delete(`${API}/admin/users/${userId}`, axiosConfig);
      
      showAlert(`${userEmail} kullanıcısı başarıyla silindi!`, 'success');
      setDeleteConfirmUser(null);
      
      // Kullanıcı listesini yenile
      await fetchUsers();
      
    } catch (err) {
      showAlert('Silme işlemi başarısız: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Toplu Kullanıcı Silme
  const handleBulkDeleteUsers = async () => {
    if (selectedUsers.length === 0) {
      showAlert('Silmek için kullanıcı seçin', 'error');
      return;
    }
    
    try {
      setLoading(true);
      let successCount = 0;
      let errorCount = 0;
      
      for (const uniqueRowId of selectedUsers) {
        try {
          // uniqueRowId formatı: "userId_email_index" - ilk parçayı al
          const userId = uniqueRowId.split('_')[0];
          await axios.delete(`${API}/admin/users/${userId}`, axiosConfig);
          successCount++;
        } catch (err) {
          errorCount++;
          console.error(`User ${uniqueRowId} silme hatası:`, err);
        }
      }
      
      showAlert(`${successCount} kullanıcı silindi${errorCount > 0 ? `, ${errorCount} hata oluştu` : ''}`, successCount > 0 ? 'success' : 'error');
      setSelectedUsers([]);
      setShowBulkDeleteConfirm(false);
      
      // Kullanıcı listesini yenile
      await fetchUsers();
      
    } catch (err) {
      showAlert('Toplu silme işlemi başarısız: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  // Tümünü Seç / Kaldır
  const handleSelectAllUsers = (checked) => {
    if (checked) {
      // Admin olmayan tüm kullanıcıları seç - benzersiz ID ile
      const nonAdminUsers = users
        .filter(u => !u.is_admin)
        .map((u, index) => `${u.id}_${u.email}_${index}`);
      setSelectedUsers(nonAdminUsers);
    } else {
      setSelectedUsers([]);
    }
  };

  // Tek kullanıcı seç/kaldır
  const handleSelectUser = (userId, checked) => {
    if (checked) {
      setSelectedUsers([...selectedUsers, userId]);
    } else {
      setSelectedUsers(selectedUsers.filter(id => id !== userId));
    }
  };


  const fetchAPISettings = async () => {
    try {
      const response = await axios.get(`${API}/news/settings`, axiosConfig);
      setApiSettings(response.data);
    } catch (err) {
      console.error('API settings fetch error:', err);
    }
  };

  const handleSaveAPIKey = async () => {
    if (!apiKey || apiKey.trim() === '') {
      showAlert('Lütfen geçerli bir API key girin', 'error');
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${API}/news/settings`, apiKey, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'text/plain'
        }
      });
      showAlert('API key başarıyla kaydedildi!', 'success');
      fetchAPISettings();
      setApiKey('');
    } catch (err) {
      showAlert('API key kaydedilemedi: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/login');
  };
  
  const fetchSupportTickets = async () => {
    try {
      const response = await axios.get(`${API}/admin/support/tickets`, axiosConfig);
      setSupportTickets(response.data);
    } catch (err) {
      console.error('Support tickets fetch error:', err);
    }
  };

  const fetchDocuments = async () => {
    try {
      const response = await axios.get(`${API}/admin/documents`, axiosConfig);
      setDocuments(response.data);
    } catch (err) {
      console.error('Documents fetch error:', err);
    }
  };

  const handleApproveDocument = async (docId) => {
    
    try {
      await axios.post(`${API}/admin/documents/${docId}/review`, {
        status: 'APPROVED',
        admin_note: 'Onaylandı'
      }, axiosConfig);
      showAlert('Belge onaylandı!', 'success');
      fetchDocuments();
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };

  const handleRejectDocument = async (docId) => {
    const note = prompt('Ret nedeni (opsiyonel):');
    
    try {
      await axios.post(`${API}/admin/documents/${docId}/review`, {
        status: 'REJECTED',
        admin_note: note || 'Reddedildi'
      }, axiosConfig);
      showAlert('Belge reddedildi!', 'info');
      fetchDocuments();
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };

  const fetchTelegramSettings = async () => {
    try {
      const response = await axios.get(`${API}/admin/telegram-settings`, axiosConfig);
      setTelegramSettings(response.data);
    } catch (err) {
      console.error('Telegram settings fetch error:', err);
    }
  };

  const handleSaveTelegramSettings = async () => {
    try {
      await axios.post(`${API}/admin/telegram-settings`, telegramSettings, axiosConfig);
      showAlert('Telegram ayarları kaydedildi!', 'success');
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };

  // ==================== BROKER FUNCTIONS ====================
  
  const fetchBrokers = async () => {
    try {
      const response = await axios.get(`${API}/brokers`, axiosConfig);
      setBrokers(response.data);
    } catch (err) {
      console.error('Error fetching brokers:', err);
    }
  };
  
  const fetchIBANSettings = async () => {
    try {
      const response = await axios.get(`${API}/admin/settings`, axiosConfig);
      setIbanSettings({
        site_logo: response.data.site_logo || '',
        bank_name: response.data.bank_name || 'GARANTİ BANKASI',
        account_holder: response.data.account_holder || 'TRADING PLATFORM A.Ş.',
        iban: response.data.iban || 'TR12 3456 7890 1234 5678 9012 34'
      });
    } catch (err) {
      console.error('Error fetching IBAN settings:', err);
    }
  };

  // Banka Hesapları Fonksiyonları
  const fetchBankAccounts = async () => {
    try {
      const response = await axios.get(`${API}/admin/bank-accounts`, axiosConfig);
      setBankAccounts(response.data);
    } catch (err) {
      console.error('Error fetching bank accounts:', err);
    }
  };

  const fetchAvailableBanks = async () => {
    try {
      const response = await axios.get(`${API}/banks/list`);
      setAvailableBanks(response.data);
    } catch (err) {
      console.error('Error fetching banks:', err);
    }
  };

  const handleAddBankAccount = async () => {
    try {
      if (!newBankAccount.bank_code || !newBankAccount.iban) {
        showAlert('Banka ve IBAN zorunludur!', 'error');
        return;
      }
      const response = await axios.post(`${API}/admin/bank-accounts`, newBankAccount, axiosConfig);
      console.log('Banka ekleme yanıtı:', response.data);
      showAlert('Banka hesabı eklendi!', 'success');
      setShowAddBankModal(false);
      setNewBankAccount({ bank_code: '', account_holder: '', iban: '' });
      fetchBankAccounts();
    } catch (err) {
      console.error('Banka ekleme hatası:', err);
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };

  // Silme onayı için state
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);

  const handleDeleteBankAccount = async (accountId) => {
    // Onay bekliyor mu?
    if (deleteConfirmId !== accountId) {
      setDeleteConfirmId(accountId);
      return;
    }
    // Onaylandı, sil
    try {
      await axios.delete(`${API}/admin/bank-accounts/${accountId}`, axiosConfig);
      showAlert('Banka hesabı silindi!', 'success');
      setDeleteConfirmId(null);
      fetchBankAccounts();
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
      setDeleteConfirmId(null);
    }
  };

  const handleToggleBankAccount = async (account) => {
    try {
      await axios.put(`${API}/admin/bank-accounts/${account.id}`, 
        { is_active: !account.is_active }, 
        axiosConfig
      );
      showAlert(account.is_active ? 'Banka pasif yapıldı!' : 'Banka aktif yapıldı!', 'success');
      fetchBankAccounts();
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };
  
  const handleUpdateIBANSettings = async () => {
    try {
      await axios.put(`${API}/admin/settings`, ibanSettings, axiosConfig);
      showAlert('IBAN ayarları başarıyla güncellendi!', 'success');
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'), 'error');
    }
  };
  
  const handleCreateBroker = async () => {
    try {
      console.log('Creating broker with data:', brokerForm);
      await axios.post(`${API}/admin/brokers`, brokerForm, axiosConfig);
      showAlert('Aracı kurum başarıyla eklendi!', 'success');
      setShowBrokerModal(false);
      setBrokerForm({ name: '', logo_url: '', color: '#003087', spk_doc_url: '' });
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      await fetchBrokers();
      console.log('Broker list refreshed');
    } catch (err) {
      console.error('Create error:', err);
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };
  
  const handleUpdateBroker = async () => {
    try {
      console.log('Updating broker with data:', brokerForm);
      await axios.put(`${API}/admin/brokers/${editingBroker.id}`, brokerForm, axiosConfig);
      showAlert('Aracı kurum başarıyla güncellendi!', 'success');
      setShowBrokerModal(false);
      setEditingBroker(null);
      setBrokerForm({ name: '', logo_url: '', color: '#003087', spk_doc_url: '' });
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      await fetchBrokers();
      console.log('Broker list refreshed');
    } catch (err) {
      console.error('Update error:', err);
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };
  
  const handleDeleteBroker = async (id) => {
    try {
      await axios.delete(`${API}/admin/brokers/${id}`, axiosConfig);
      showAlert('Aracı kurum silindi!', 'success');
      fetchBrokers();
    } catch (err) {
      showAlert('Hata: ' + err.response?.data?.detail, 'error');
    }
  };

  const handleSetHomepage = async (brokerId) => {
    try {
      await axios.post(`${API}/admin/brokers/${brokerId}/set-homepage`, {}, axiosConfig);
      showAlert('Ana sayfa başarıyla ayarlandı!', 'success');
      fetchBrokers();
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };
  
  const openBrokerModal = (broker = null) => {
    if (broker) {
      setEditingBroker(broker);
      setBrokerForm({
        name: broker.name,
        logo_url: broker.logo_url,
        color: broker.color,
        spk_doc_url: broker.spk_doc_url || ''
      });
    } else {
      setEditingBroker(null);
      setBrokerForm({ name: '', logo_url: '', color: '#003087', spk_doc_url: '' });
    }
    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    setShowBrokerModal(true);
  };
  
  const openLandingPageEditor = (broker) => {
    setEditingLandingPage(broker);
    const config = broker.landing_page_config || {
      hero_title: 'Hoş Geldiniz',
      hero_subtitle: broker.name,
      hero_button_text: 'Hemen Başla',
      sections: []
    };
    setLandingPageConfig(config);
    setShowLandingPageEditor(true);
  };
  
  const saveLandingPageConfig = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API}/admin/brokers/${editingLandingPage.id}/landing-page`,
        { landing_page_config: landingPageConfig },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      showAlert('Landing page kaydedildi!', 'success');
      setShowLandingPageEditor(false);
      fetchBrokers();
    } catch (error) {
      console.error('Landing page kaydetme hatası:', error);
      showAlert('Hata oluştu!', 'error');
    }
  };
  
  const handleLogoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      console.log('No file selected');
      return;
    }
    
    console.log('File selected:', file.name, file.type, file.size);
    
    // Check file type
    const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];
    if (!validTypes.includes(file.type)) {
      showAlert('Sadece PNG, JPG ve SVG dosyaları yüklenebilir!', 'error');
      return;
    }
    
    // Check file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      showAlert('Dosya boyutu 5MB\'dan küçük olmalıdır!', 'error');
      return;
    }
    
    setUploadingLogo(true);
    
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await axios.post(`${API}/admin/upload-broker-logo`, formData, {
        ...axiosConfig,
        headers: {
          ...axiosConfig.headers,
          'Content-Type': 'multipart/form-data'
        }
      });
      
      console.log('Upload response:', response.data);
      
      // Store relative URL - will be resolved at display time
      const logoUrl = response.data.logo_url;
      console.log('Logo URL:', logoUrl);
      
      // Use functional update to ensure latest state
      setBrokerForm(prev => ({
        ...prev, 
        logo_url: logoUrl
      }));
      
      console.log('State updated with logo_url:', logoUrl);
      showAlert('Logo başarıyla yüklendi!', 'success');
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setUploadingLogo(false);
    }
  };

  const fetchConversations = async () => {
    try {
      const response = await axios.get(`${API}/admin/support/conversations`, axiosConfig);
      const newConversations = response.data.conversations || [];
      setConversations(newConversations);
      
      // If a conversation is selected, update it with new messages
      if (selectedConversation) {
        const updated = newConversations.find(c => c.user_id === selectedConversation.user_id);
        if (updated) {
          setSelectedConversation(updated);
        }
      }
    } catch (err) {
      console.error('Conversations fetch error:', err);
    }
  };

  const handleSendReply = async () => {
    if (!replyMessage.trim() || !selectedConversation) return;

    try {
      await axios.post(`${API}/admin/support/reply`, {
        user_id: selectedConversation.user_id,
        user_email: selectedConversation.user_email,
        message: replyMessage
      }, axiosConfig);
      
      setReplyMessage('');
      await fetchConversations();
      // Scroll to bottom after sending
      setTimeout(() => {
        if (adminMessagesEndRef.current) {
          adminMessagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } catch (err) {
      showAlert('Hata: ' + (err.response?.data?.detail || err.message), 'error');
    }
  };

  // Scroll to bottom when conversation changes or messages update
  useEffect(() => {
    if (selectedConversation && adminMessagesEndRef.current) {
      adminMessagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [selectedConversation]);


  const fetchTicketDetails = async (ticketId) => {
    try {
      const response = await axios.get(`${API}/admin/support/tickets/${ticketId}`, axiosConfig);
      setSelectedTicket(response.data.ticket);
      setTicketMessages(response.data.messages);
    } catch (err) {
      console.error('Ticket details fetch error:', err);
    }
  };

  const handleSendAdminReply = async () => {
    if (!adminReply.trim()) return;
    
    try {
      setLoading(true);
      await axios.post(`${API}/admin/support/tickets/${selectedTicket.id}/messages`, {
        message: adminReply
      }, axiosConfig);
      
      setAdminReply('');
      fetchTicketDetails(selectedTicket.id);
      fetchSupportTickets();
    } catch (err) {
      showAlert('Mesaj gönderilemedi: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateTicketStatus = async (ticketId, newStatus) => {
    try {
      setLoading(true);
      await axios.put(`${API}/admin/support/tickets/${ticketId}/status`, 
        { status: newStatus },
        axiosConfig
      );
      
      fetchTicketDetails(ticketId);
      fetchSupportTickets();
      showAlert('Durum güncellendi!', 'success');
    } catch (err) {
      showAlert('Durum güncellenemedi: ' + (err.response?.data?.detail || err.message), 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Kullanıcı Silme Onay Modal - EN ÜSTTE */}
      {deleteConfirmUser && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[9999] p-4" style={{position: 'fixed', top: 0, left: 0, right: 0, bottom: 0}}>
          <div className="bg-gray-800 rounded-xl p-6 max-w-md w-full border-2 border-red-500 shadow-2xl">
            <div className="text-center">
              <div className="text-5xl mb-4"></div>
              <h3 className="text-xl font-bold text-white mb-2">Kullanıcıyı Sil</h3>
              <p className="text-gray-300 mb-4">
                <span className="text-red-400 font-bold">{deleteConfirmUser.email}</span> 
                <br />kullanıcısını silmek istediğinize emin misiniz?
              </p>
              <p className="text-gray-500 text-sm mb-6">
                Bu işlem geri alınamaz. Kullanıcıya ait tüm veriler silinecektir.
              </p>
              <div className="flex gap-3 justify-center">
                <button
                  onClick={() => setDeleteConfirmUser(null)}
                  className="px-6 py-3 bg-gray-600 hover:bg-gray-500 rounded-lg font-semibold transition-colors text-white"
                >
                  Hayır, İptal
                </button>
                <button
                  onClick={() => handleDeleteUser(deleteConfirmUser.id, deleteConfirmUser.email)}
                  className="px-6 py-3 bg-red-600 hover:bg-red-700 rounded-lg font-semibold transition-colors text-white"
                >
                  Evet, Sil
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <header className="bg-gray-800 border-b border-gray-700 px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {/* MOBILE MENU BUTTON - LEFT SIDE */}
            <button
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="lg:hidden text-white hover:text-blue-400 transition-colors"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            
            <h1 className="text-xl sm:text-2xl font-bold text-purple-500">Admin Panel</h1>
          </div>
          
          <div className="flex items-center gap-2 sm:gap-2 sm:p-4">
            <button
              onClick={() => navigate('/dashboard')}
              className="hidden sm:block px-3 sm:px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors text-sm"
            >
              ← Trading
            </button>
            <button
              onClick={() => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/';
              }}
              className="px-2 sm:px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-medium text-sm"
            >
              Çıkış
            </button>
            <div className="hidden sm:block text-sm text-gray-400">{user.email}</div>
          </div>
        </div>
      </header>

      {/* Dashboard Stats */}
      {dashboardStats && (
        <div className="bg-gray-800 border-b border-gray-700 p-2 sm:p-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2 sm:gap-3">
            <StatCard title="ID" value={dashboardStats.total_users} />
            <StatCard title="Bakiye" value={`${dashboardStats.total_balance.toFixed(2)} TL`} color="text-green-400" />
            <StatCard title="Kredi" value="0 TL" />
            <StatCard title="Kar" value={`${dashboardStats.total_profit.toFixed(2)} TL`} color={dashboardStats.total_profit >= 0 ? 'text-green-400' : 'text-red-400'} />
            <StatCard title="Varlık" value={`${dashboardStats.total_equity.toFixed(2)} TL`} />
            <StatCard title="Margin" value={`${dashboardStats.total_margin.toFixed(2)} TL`} />
            <StatCard title="Pozisyon" value={dashboardStats.total_positions} />
          </div>
        </div>
      )}

      <div className="flex relative">
        {/* Mobile Menu Overlay */}
        {showMobileMenu && (
          <div 
            className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
            onClick={() => setShowMobileMenu(false)}
          />
        )}

        {/* Sidebar */}
        <div className={`${showMobileMenu ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 fixed lg:static top-0 left-0 w-64 h-screen lg:h-auto bg-gray-800 border-r border-gray-700 z-40 transition-transform duration-300 overflow-y-auto pt-20 pb-20 lg:pt-0 lg:pb-0`}>
          <nav className="p-2">
            <TabButton active={activeTab === 'traders'} onClick={() => { setActiveTab('traders'); setShowMobileMenu(false); }} icon={Users}>Kullanıcılar</TabButton>
            {/* <TabButton active={activeTab === 'positions'} onClick={() => { setActiveTab('positions'); setShowMobileMenu(false); }} icon={Activity}>Açık Pozisyonlar</TabButton> */}
            <TabButton active={activeTab === 'orders'} onClick={() => { setActiveTab('orders'); setShowMobileMenu(false); }} icon={FileText}>Emir Pozisyonları</TabButton>
            <TabButton active={activeTab === 'documents'} onClick={() => { setActiveTab('documents'); setShowMobileMenu(false); }} icon={Shield}>Belge Onayları</TabButton>
            <TabButton active={activeTab === 'deposits'} onClick={() => { setActiveTab('deposits'); setShowMobileMenu(false); }} icon={Download}>Yatırım Talepleri</TabButton>
            <TabButton active={activeTab === 'withdrawals'} onClick={() => { setActiveTab('withdrawals'); setShowMobileMenu(false); }} icon={Upload}>Çekim Talepleri</TabButton>
            <TabButton active={activeTab === 'brokers'} onClick={() => { setActiveTab('brokers'); setShowMobileMenu(false); }} icon={Building2}>Aracı Kurumlar</TabButton>
            <TabButton active={activeTab === 'settings'} onClick={() => { setActiveTab('settings'); setShowMobileMenu(false); }} icon={Landmark}>Banka Hesapları</TabButton>
            <TabButton active={activeTab === 'crypto-settings'} onClick={() => { setActiveTab('crypto-settings'); setShowMobileMenu(false); }} icon={Bitcoin}>Kripto Ayarları</TabButton>
            <TabButton active={activeTab === 'telegram'} onClick={() => { setActiveTab('telegram'); setShowMobileMenu(false); }} icon={Smartphone}>Telegram Ayarları</TabButton>
            <TabButton active={activeTab === 'live-chat'} onClick={() => { setActiveTab('live-chat'); setShowMobileMenu(false); }} icon={MessageSquare}>
              Canlı Destek
              {liveChatUnreadCount > 0 && (
                <span className="ml-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                  {liveChatUnreadCount}
                </span>
              )}
            </TabButton>
            <TabButton active={activeTab === 'news'} onClick={() => { setActiveTab('news'); setShowMobileMenu(false); }} icon={Newspaper}>Haberler</TabButton>
            <TabButton active={activeTab === 'notifications'} onClick={() => { setActiveTab('notifications'); setShowMobileMenu(false); }} icon={Bell}>Bildirim Gönder</TabButton>
            <TabButton active={activeTab === 'email'} onClick={() => { setActiveTab('email'); setShowMobileMenu(false); }} icon={Mail}>E-posta Gönder</TabButton>
            <TabButton active={activeTab === 'online'} onClick={() => { setActiveTab('online'); setShowMobileMenu(false); }} icon={Activity}>Çevrimiçi Kullanıcılar</TabButton>
            <TabButton active={activeTab === 'margin'} onClick={() => { setActiveTab('margin'); setShowMobileMenu(false); }} icon={AlertTriangle}>Margin Çağrıları</TabButton>
            <TabButton active={activeTab === 'assets'} onClick={() => { setActiveTab('assets'); setShowMobileMenu(false); }} icon={BarChart3}>Varlıklar</TabButton>
            <TabButton active={activeTab === 'discovery'} onClick={() => { setActiveTab('discovery'); setShowMobileMenu(false); }} icon={PieChart}>Yeni Enstrümanlar</TabButton>
            {/* API Ayarları gizlendi - sistem üzerinden yönetilecek */}
            {/* <TabButton active={activeTab === 'api-settings'} onClick={() => { setActiveTab('api-settings'); setShowMobileMenu(false); }} icon={Settings}>API Ayarları</TabButton> */}
            <TabButton active={activeTab === 'leverage-groups'} onClick={() => { setActiveTab('leverage-groups'); setShowMobileMenu(false); }} icon={PieChart}>Kaldıraç Grupları</TabButton>
            <TabButton active={activeTab === 'login-designs'} onClick={() => { setActiveTab('login-designs'); setShowMobileMenu(false); }} icon={Globe}>Giriş Seçenekleri</TabButton>
            <TabButton active={activeTab === 'managers'} onClick={() => { setActiveTab('managers'); setShowMobileMenu(false); }} icon={UserCheck}>Yöneticiler</TabButton>
            <TabButton active={activeTab === 'backup'} onClick={() => { setActiveTab('backup'); setShowMobileMenu(false); }} icon={HardDrive}>💾 Yedekleme</TabButton>
            <TabButton active={activeTab === 'audit-log'} onClick={() => { setActiveTab('audit-log'); setShowMobileMenu(false); }} icon={Shield} data-testid="tab-audit-log">🔍 Denetim Kaydı</TabButton>
            {/* <TabButton active={activeTab === 'manipulate'} onClick={() => { setActiveTab('manipulate'); setShowMobileMenu(false); }} icon={Settings}>Manipüle</TabButton> */}
          </nav>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-2 sm:p-4 lg:p-6 overflow-y-auto w-full" style={{ maxHeight: 'calc(100vh - 169px)' }}>
          {/* Trader Accounts */}
          {activeTab === 'traders' && (
            <div>
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
                <h2 className="text-lg sm:text-xl font-bold">Kullanıcılar ({users.filter(u => 
                  !searchQuery || 
                  u.email?.toLowerCase().includes(searchQuery.toLowerCase()) || 
                  u.full_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                  u.id?.toString().includes(searchQuery)
                ).length})</h2>
                <div className="flex gap-2 w-full sm:w-auto flex-wrap">
                  <input
                    type="text"
                    placeholder="🔍 İsim, email veya ID ara..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="flex-1 sm:w-64 px-3 py-2 bg-gray-700 text-white rounded-lg text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <button 
                    type="button"
                    onClick={() => { 
                      console.log('🟢 Yeni Kullanıcı butonu tıklandı!');
                      setShowCreateUserModal(true); 
                    }} 
                    className="px-3 py-2 bg-green-600 hover:bg-green-700 rounded text-sm whitespace-nowrap"
                  >
                    + Yeni Kullanıcı
                  </button>
                  <button onClick={fetchUsers} disabled={usersLoading} className="px-3 py-2 bg-blue-600 hover:bg-blue-700 rounded text-sm whitespace-nowrap disabled:opacity-50">
                    {usersLoading ? '⏳ Yükleniyor...' : '↻ Yenile'}
                  </button>
                </div>
              </div>
              
              {/* Toplu Silme Kontrolleri */}
              {selectedUsers.length > 0 && (
                <div className="bg-red-900/30 border border-red-500 rounded-lg p-3 mb-4 flex items-center justify-between flex-wrap gap-2">
                  <span className="text-red-400 font-semibold">
                    🗑️ {selectedUsers.length} kullanıcı seçildi
                  </span>
                  <div className="flex gap-2">
                    <button 
                      onClick={() => setSelectedUsers([])}
                      className="px-3 py-1 bg-gray-600 hover:bg-gray-700 rounded text-sm"
                    >
                      Seçimi Kaldır
                    </button>
                    {!showBulkDeleteConfirm ? (
                      <button 
                        onClick={() => setShowBulkDeleteConfirm(true)}
                        className="px-3 py-1 bg-red-600 hover:bg-red-700 rounded text-sm font-semibold"
                      >
                        🗑️ Seçilenleri Sil
                      </button>
                    ) : (
                      <div className="flex items-center gap-2">
                        <span className="text-yellow-400 text-sm">Emin misiniz?</span>
                        <button 
                          onClick={handleBulkDeleteUsers}
                          disabled={loading}
                          className="px-3 py-1 bg-red-600 hover:bg-red-700 rounded text-sm font-semibold disabled:opacity-50"
                        >
                          {loading ? '⏳ Siliniyor...' : '✓ Evet, Sil'}
                        </button>
                        <button 
                          onClick={() => setShowBulkDeleteConfirm(false)}
                          className="px-3 py-1 bg-gray-600 hover:bg-gray-700 rounded text-sm"
                        >
                          İptal
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
              
              {/* Loading göstergesi */}
              {usersLoading ? (
                <div className="bg-gray-800 rounded-lg p-8 text-center">
                  <div className="inline-flex items-center gap-3 text-blue-400">
                    <svg className="animate-spin h-6 w-6" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span className="text-lg">Kullanıcılar yükleniyor...</span>
                  </div>
                </div>
              ) : (
              <div className="bg-gray-800 rounded-lg overflow-x-auto">
                <table className="w-full text-sm min-w-[800px]">
                  <thead className="bg-gray-700">
                    <tr>
                      <th className="px-2 py-3 text-center w-10">
                        {/* Checkbox column header */}
                      </th>
                      <th className="px-4 py-3 text-left">ID</th>
                      <th className="px-4 py-3 text-left">Email</th>
                      <th className="px-4 py-3 text-left">Name</th>
                      <th className="px-4 py-3 text-left">Balance</th>
                      <th className="px-4 py-3 text-left">Hesap Tipi</th>
                      <th className="px-4 py-3 text-left">Durum</th>
                      <th className="px-4 py-3 text-left">Created</th>
                      <th className="px-4 py-3 text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users
                      .filter(u => 
                        !searchQuery || 
                        u.email?.toLowerCase().includes(searchQuery.toLowerCase()) || 
                        u.full_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        u.id?.toString().includes(searchQuery)
                      )
                      .map((u, index) => {
                        // Her satır için benzersiz ID oluştur (duplicate kullanıcılar için)
                        const uniqueRowId = `${u.id}_${u.email}_${index}`;
                        return (
                      <tr key={uniqueRowId} className={`border-t border-gray-700 hover:bg-gray-750 ${selectedUsers.includes(uniqueRowId) ? 'bg-red-900/20' : ''}`}>
                        <td className="px-2 py-3 text-center">
                          {!u.is_admin && (
                            <input
                              type="checkbox"
                              checked={selectedUsers.includes(uniqueRowId)}
                              onChange={(e) => handleSelectUser(uniqueRowId, e.target.checked)}
                              className="w-4 h-4 rounded bg-gray-600 border-gray-500 text-red-600 focus:ring-red-500"
                            />
                          )}
                          {u.is_admin && <span className="text-yellow-400">👑</span>}
                        </td>
                        <td className="px-4 py-3 font-mono text-xs text-yellow-400" title={u.id}>{u.id}</td>
                        <td className="px-4 py-3 font-semibold text-blue-300">{u.email}</td>
                        <td className="px-4 py-3">{u.full_name || '-'}</td>
                        <td className="px-4 py-3 font-mono text-green-400">
                          {u.balance.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} TL
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <select
                              value={u.account_type || 'STANDART'}
                              onChange={(e) => handleChangeAccountType(u.id, e.target.value)}
                              className="bg-gray-700 text-white border border-gray-600 rounded px-2 py-1 text-xs"
                            >
                              <option value="STANDART">Standart</option>
                              <option value="VIP">VIP</option>
                              <option value="KOMISYONSUZ">Komisyonsuz</option>
                            </select>
                            <span className={`px-2 py-1 rounded text-xs font-bold ${
                              (u.account_type || 'STANDART') === 'VIP' 
                                ? 'bg-yellow-900 text-yellow-300' 
                                : (u.account_type || 'STANDART') === 'KOMISYONSUZ'
                                ? 'bg-green-900 text-green-300'
                                : 'bg-gray-700 text-gray-300'
                            }`}>
                              {(u.account_type || 'STANDART') === 'VIP' ? 'VIP' : 
                               (u.account_type || 'STANDART') === 'KOMISYONSUZ' ? 'Komisyonsuz' : 
                               'Standart'}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          {u.is_banned ? (
                            <span className="px-2 py-1 bg-red-900 text-red-300 rounded text-xs font-bold">
                              BANLI
                            </span>
                          ) : (
                            <span className="px-2 py-1 bg-green-900 text-green-300 rounded text-xs">
                              AKTİF
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-400">
                          {new Date(u.created_at).toLocaleDateString('tr-TR')}
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex gap-1">
                            <button
                              data-user-id={u.id}
                              data-user-email={u.email}
                              onClick={(e) => {
                                const userId = e.currentTarget.getAttribute('data-user-id');
                                const userEmail = e.currentTarget.getAttribute('data-user-email');
                                console.log('🔍 Detay tıklandı - ID:', userId, 'Email:', userEmail);
                                fetchUserDetail(userId);
                              }}
                              className="px-2 py-1 bg-purple-600 hover:bg-purple-700 rounded text-xs"
                            >
                              Detay
                            </button>
                            <button
                              onClick={() => openBalanceModal(u.id, u.email)}
                              className="px-2 py-1 bg-green-600 hover:bg-green-700 rounded text-xs"
                              title="Bakiye Güncelle"
                            >
                              💰
                            </button>
                            {!u.is_admin && (
                              <>
                                <button
                                  onClick={() => handleBanToggle(u.id, u.email, u.is_banned)}
                                  className={`px-2 py-1 rounded text-xs ${
                                    u.is_banned 
                                      ? 'bg-green-600 hover:bg-green-700' 
                                      : 'bg-red-600 hover:bg-red-700'
                                  }`}
                                  title={u.is_banned ? "Banı Kaldır" : "Banla"}
                                >
                                  {u.is_banned ? 'Evet' : 'Hayır'}
                                </button>
                                <button
                                  onClick={() => {
                                    console.log('🗑️ Delete button clicked for:', u.email);
                                    setDeleteConfirmUser({ id: u.id, email: u.email });
                                  }}
                                  className="px-2 py-1 bg-red-800 hover:bg-red-900 rounded text-xs"
                                  title="Kullanıcıyı Sil"
                                >
                                  🗑️
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              )}
            </div>
          )}

          {/* Open Positions */}
          {activeTab === 'positions' && (
            <div>
              <h2 className="text-lg sm:text-xl font-bold mb-4">Open Positions ({allPositions.length})</h2>
              <div className="bg-gray-800 rounded-lg overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-700">
                    <tr>
                      <th className="px-4 py-3 text-left">User</th>
                      <th className="px-4 py-3 text-left">Symbol</th>
                      <th className="px-4 py-3 text-left">Amount</th>
                      <th className="px-4 py-3 text-left">Avg Price</th>
                      <th className="px-4 py-3 text-left">Current</th>
                      <th className="px-4 py-3 text-left">P/L</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allPositions.map(p => (
                      <tr key={p.id} className="border-t border-gray-700">
                        <td className="px-4 py-3 text-xs" title={p.user_email || ''}>{p.user_name || p.user_email || 'Unknown'}</td>
                        <td className="px-4 py-3 font-bold">{p.asset_symbol}</td>
                        <td className="px-4 py-3">{p.amount}</td>
                        <td className="px-4 py-3 font-mono">{p.avg_buy_price?.toFixed(2)}</td>
                        <td className="px-4 py-3 font-mono">{p.current_price?.toFixed(2)}</td>
                        <td className={`px-4 py-3 ${(p.profit_loss || 0) >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                          {(p.profit_loss || 0) >= 0 ? '+' : ''}{(p.profit_loss || 0).toFixed(2)} TL
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Pending Orders */}
          {activeTab === 'orders' && (
            <div>
              <h2 className="text-lg sm:text-xl font-bold mb-4">Pending Orders ({pendingOrders.length})</h2>
              <div className="bg-gray-800 rounded-lg overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-700">
                    <tr>
                      <th className="px-4 py-3 text-left">User</th>
                      <th className="px-4 py-3 text-left">Symbol</th>
                      <th className="px-4 py-3 text-left">Type</th>
                      <th className="px-4 py-3 text-left">Side</th>
                      <th className="px-4 py-3 text-left">Amount</th>
                      <th className="px-4 py-3 text-left">Limit Price</th>
                      <th className="px-4 py-3 text-left">Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pendingOrders.map(o => (
                      <tr key={o.id} className="border-t border-gray-700">
                        <td className="px-4 py-3 text-xs">{o.user_email || 'Unknown'}</td>
                        <td className="px-4 py-3 font-bold">{o.asset_symbol}</td>
                        <td className="px-4 py-3">
                          <span className="px-2 py-1 bg-gray-700 rounded text-xs">{o.order_type}</span>
                        </td>
                        <td className="px-4 py-3">
                          <span className={`px-2 py-1 rounded text-xs ${
                            o.transaction_type === 'BUY' ? 'bg-green-900 text-green-300' : 'bg-red-900 text-red-300'
                          }`}>
                            {o.transaction_type}
                          </span>
                        </td>
                        <td className="px-4 py-3">{o.amount}</td>
                        <td className="px-4 py-3 font-mono">{o.limit_price?.toFixed(2) || '-'}</td>
                        <td className="px-4 py-3 text-xs text-gray-400">
                          {new Date(o.created_at).toLocaleString('tr-TR')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Deposit Requests */}
          {activeTab === 'deposits' && (
            <div>
              <h2 className="text-lg sm:text-xl font-bold mb-4">Deposit Requests ({depositRequests.length})</h2>
              <div className="bg-gray-800 rounded-lg overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-700">
                    <tr>
                      <th className="px-4 py-3 text-left">Kullanıcı</th>
                      <th className="px-4 py-3 text-left">Tutar</th>
                      <th className="px-4 py-3 text-left">Yöntem</th>
                      <th className="px-4 py-3 text-left">Durum</th>
                      <th className="px-4 py-3 text-left">Tarih</th>
                      <th className="px-4 py-3 text-left">İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {depositRequests.map(d => (
                      <tr key={d.id} className="border-t border-gray-700">
                        <td className="px-4 py-3">
                          <div className="font-semibold text-white">{d.user_name || d.full_name || 'Bilinmiyor'}</div>
                          <div className="font-mono text-xs text-gray-400">{d.user_id?.slice(0, 8)}...</div>
                        </td>
                        <td className="px-4 py-3 font-bold text-green-400">{d.amount?.toFixed(2)} TL</td>
                        <td className="px-4 py-3">
                          <span className="px-2 py-1 bg-gray-700 rounded text-xs">{d.method}</span>
                        </td>
                        <td className="px-4 py-3">
                          <StatusBadge status={d.status} />
                        </td>
                        <td className="px-4 py-3 text-xs text-gray-400">
                          {new Date(d.created_at).toLocaleString('tr-TR')}
                        </td>
                        <td className="px-4 py-3">
                          {d.status === 'PENDING' && (
                            <div className="flex gap-1">
                              <button
                                onClick={() => handleApproveDeposit(d.id)}
                                className="px-2 py-1 bg-green-600 hover:bg-green-700 rounded text-xs"
                              >
                                Onayla
                              </button>
                              <button
                                onClick={() => handleRejectDeposit(d.id)}
                                className="px-2 py-1 bg-red-600 hover:bg-red-700 rounded text-xs"
                              >
                                Reddet
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Withdrawal Requests */}
          {activeTab === 'withdrawals' && (
            <div>
              <h2 className="text-lg sm:text-xl font-bold mb-4">Çekim Talepleri ({withdrawalRequests.length})</h2>
              {withdrawalRequests.length === 0 ? (
                <div className="bg-gray-800 rounded-lg p-8 text-center text-gray-400">
                  Çekim talebi bulunmuyor
                </div>
              ) : (
                <div className="bg-gray-800 rounded-lg overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-700">
                      <tr>
                        <th className="px-4 py-3 text-left">Email</th>
                        <th className="px-4 py-3 text-left">Tutar</th>
                        <th className="px-4 py-3 text-left">IBAN</th>
                        <th className="px-4 py-3 text-left">Hesap Sahibi</th>
                        <th className="px-4 py-3 text-left">Durum</th>
                        <th className="px-4 py-3 text-left">Tarih</th>
                        <th className="px-4 py-3 text-left">İşlemler</th>
                      </tr>
                    </thead>
                    <tbody>
                      {withdrawalRequests.map(w => (
                        <tr key={w.id} className="border-t border-gray-700 hover:bg-gray-750">
                          <td className="px-4 py-3 text-xs">{w.user_email}</td>
                          <td className="px-4 py-3 font-bold text-red-400">₺{w.amount.toFixed(2)}</td>
                          <td className="px-4 py-3 font-mono text-xs">{w.iban}</td>
                          <td className="px-4 py-3 text-xs">{w.account_holder}</td>
                          <td className="px-4 py-3">
                            <StatusBadge status={w.status} />
                          </td>
                          <td className="px-4 py-3 text-xs text-gray-400">
                            {new Date(w.created_at).toLocaleString('tr-TR')}
                          </td>
                          <td className="px-4 py-3">
                            {w.status === 'PENDING' && (
                              <div className="flex gap-1">
                                <button
                                  onClick={() => handleApproveWithdrawal(w.id)}
                                  className="px-3 py-1 bg-green-600 hover:bg-green-700 rounded text-xs font-semibold"
                                >
                                  Onayla
                                </button>
                                <button
                                  onClick={() => handleRejectWithdrawal(w.id)}
                                  className="px-3 py-1 bg-red-600 hover:bg-red-700 rounded text-xs font-semibold"
                                >
                                  Reddet
                                </button>
                              </div>
                            )}
                            {w.status !== 'PENDING' && (
                              <span className="text-xs text-gray-500">
                                {w.reviewed_by && `İncelendi: ${w.reviewed_by}`}
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* Online Users */}
          {activeTab === 'online' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Çevrimiçi Kullanıcılar ({onlineUsers.length})</h2>
              
              {onlineUsers.length === 0 ? (
                <div className="bg-gray-800 rounded-lg p-8 text-center text-gray-400">
                  <div className="text-5xl mb-4">👥</div>
                  <p>Şu anda çevrimiçi kullanıcı yok</p>
                </div>
              ) : (
                <div className="bg-gray-800 rounded-lg overflow-x-auto">
                  <table className="w-full min-w-[600px]">
                    <thead className="bg-gray-700">
                      <tr>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase">Durum</th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase">Email</th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase">Ad Soyad</th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase hidden md:table-cell">Bakiye</th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase hidden lg:table-cell">Son Aktivite</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700">
                      {onlineUsers.map(u => (
                        <tr key={u.id} className="hover:bg-gray-750">
                          <td className="px-4 sm:px-6 py-4">
                            <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                          </td>
                          <td className="px-4 sm:px-6 py-4 text-sm font-medium">{u.email}</td>
                          <td className="px-4 sm:px-6 py-4 text-sm">{u.full_name || '-'}</td>
                          <td className="px-4 sm:px-6 py-4 text-sm font-mono hidden md:table-cell">₺{u.balance?.toFixed(2) || '0.00'}</td>
                          <td className="px-4 sm:px-6 py-4 text-sm text-gray-400 hidden lg:table-cell">
                            {u.last_active ? new Date(u.last_active).toLocaleString('tr-TR') : 'Bilinmiyor'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* Margin Call */}
          {activeTab === 'margin' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Teminat Çağrısı ({marginCallUsers.length})</h2>
              
              {marginCallUsers.length === 0 ? (
                <div className="bg-gray-800 rounded-lg p-8 text-center text-gray-400">
                  <div className="text-5xl mb-4"></div>
                  <p>Teminat çağrısı olan kullanıcı yok</p>
                </div>
              ) : (
                <div className="bg-gray-800 rounded-lg overflow-x-auto">
                  <table className="w-full min-w-[600px]">
                    <thead className="bg-gray-700">
                      <tr>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase">Email</th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase hidden sm:table-cell">Ad Soyad</th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase">Bakiye</th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase hidden md:table-cell">Teminat Seviyesi</th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase">Durum</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700">
                      {marginCallUsers.map(u => (
                        <tr key={u.id} className="hover:bg-gray-750">
                          <td className="px-4 sm:px-6 py-4 text-sm font-medium">{u.email}</td>
                          <td className="px-4 sm:px-6 py-4 text-sm hidden sm:table-cell">{u.full_name || '-'}</td>
                          <td className="px-4 sm:px-6 py-4 text-sm font-mono">₺{u.balance.toFixed(2)}</td>
                          <td className="px-4 sm:px-6 py-4 text-sm hidden md:table-cell">
                            <span className="text-red-400 font-bold">{u.margin_level.toFixed(2)}%</span>
                          </td>
                          <td className="px-4 sm:px-6 py-4">
                            <span className="px-2 py-1 bg-red-900 text-red-300 rounded text-xs font-semibold">
                              TEMİNAT ÇAĞRISI
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* API Settings Tab */}
          {activeTab === 'api-settings' && (
            <div>
              <h2 className="text-lg sm:text-xl font-bold mb-4">API Settings</h2>
              
              {/* Current API Settings Display */}
              {apiSettings && (
                <div className="bg-gray-800 p-2 sm:p-4 rounded-lg mb-6">
                  <h3 className="text-base sm:text-lg font-bold mb-3">📡 CryptoPanic News API</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <span className="text-gray-400">API Key:</span>
                      <span className="font-mono text-sm">
                        {apiSettings.api_key_preview || 'Not configured'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-400">Status:</span>
                      <span className={`px-2 py-1 rounded text-xs ${
                        apiSettings.has_api_key ? 'bg-green-900 text-green-300' : 'bg-yellow-900 text-yellow-300'
                      }`}>
                        {apiSettings.has_api_key ? 'Aktif' : 'Mock Mode'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-400">Mode:</span>
                      <span className="text-sm">
                        {apiSettings.mock_mode ? 'Using demo data' : 'Using real CryptoPanic API'}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* API Key Input Form */}
              <div className="bg-gray-800 p-2 sm:p-4 rounded-lg">
                <h3 className="text-base sm:text-lg font-bold mb-2">🔑 Update CryptoPanic API Key</h3>
                <div className="bg-blue-900/30 border border-blue-500 rounded p-3 mb-4 text-sm">
                  <div className="font-semibold mb-2">Nasıl API Key Alınır:</div>
                  <ol className="list-decimal list-inside space-y-1 text-gray-300">
                    <li>🌐 <a href="https://cryptopanic.com/developers/api/" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">cryptopanic.com/developers/api/</a> adresine git</li>
                    <li>Ücretsiz hesap oluştur (Sign Up)</li>
                    <li>Developer bölümünden API key'ini al</li>
                    <li>Key'i buraya yapıştır ve kaydet</li>
                  </ol>
                  <div className="mt-2 text-xs text-gray-400">
                    Free tier: 2 req/sec limitli ama yeterli!
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-gray-300 mb-2 text-sm font-semibold">CryptoPanic API Key</label>
                    <input
                      type="text"
                      value={apiKey}
                      onChange={(e) => setApiKey(e.target.value)}
                      placeholder="API key'inizi buraya yapıştırın"
                      className="w-full bg-gray-700 border-gray-600 rounded px-3 py-2 font-mono text-sm"
                    />
                    <div className="text-xs text-gray-400 mt-1">
                      Bu key ile gerçek zamanlı kripto haberleri çekilecek
                    </div>
                  </div>
                  
                  <button
                    onClick={handleSaveAPIKey}
                    disabled={loading}
                    className="px-3 sm:px-4 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 rounded font-semibold transition-colors"
                  >
                    {loading ? '⏳ Kaydediliyor...' : '💾 API Key Kaydet'}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Leverage Groups Tab (Yeni Matematik — Spec Bölüm 2 & 11) */}
          {activeTab === 'leverage-groups' && (
            <div>
              <iframe 
                src="/admin/leverage-groups" 
                className="w-full h-screen border-0 rounded-lg"
                title="Kaldıraç Grupları"
              />
            </div>
          )}

          {/* Managers Tab */}
          {activeTab === 'managers' && <ManagerManagement />}

          {/* Market API Tab */}
          {/* market-api tab removed */}

          {/* Login Designs Tab */}
          {activeTab === 'login-designs' && <LoginDesignGallery />}

          {/* Paket 1 — Denetim Kaydı (Audit Log) */}
          {activeTab === 'audit-log' && (
            <AuditLogViewer />
          )}

          {/* Backup/Restore Tab */}
          {activeTab === 'backup' && (
            <div className="space-y-6">
              <h1 className="text-2xl font-bold">💾 Yedekleme ve Geri Yükleme</h1>
              
              {/* Yedek Al Bölümü */}
              <div className="bg-gray-800 rounded-lg p-6">
                <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                  <Database className="w-6 h-6 text-blue-400" />
                  Tam Yedek Oluştur
                </h2>
                <p className="text-gray-400 mb-4">
                  Tüm sistem verilerini tek bir dosyaya yedekler:
                </p>
                <ul className="text-sm text-gray-400 mb-4 space-y-1 list-disc list-inside">
                  <li>👥 Kullanıcılar ve bakiyeleri</li>
                  <li>📊 Açık pozisyonlar</li>
                  <li>✅ Tamamlanan işlemler</li>
                  <li>⏳ Bekleyen emirler</li>
                  <li>💰 Yatırım talepleri</li>
                  <li>💸 Çekim talepleri</li>
                  <li>🏦 Banka hesapları (IBAN)</li>
                  <li>📱 Telegram/WhatsApp ayarları</li>
                  <li>⚙️ Tüm sistem ayarları</li>
                </ul>
                <button
                  onClick={handleCreateBackup}
                  disabled={backupLoading}
                  className="px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 rounded-lg font-semibold flex items-center gap-2"
                >
                  {backupLoading ? (
                    <>
                      <RefreshCw className="w-5 h-5 animate-spin" />
                      Yedekleniyor...
                    </>
                  ) : (
                    <>
                      <Save className="w-5 h-5" />
                      Yedek Al ve İndir
                    </>
                  )}
                </button>
              </div>
              
              {/* Geri Yükle Bölümü */}
              <div className="bg-gray-800 rounded-lg p-6">
                <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                  <RotateCcw className="w-6 h-6 text-green-400" />
                  Yedekten Geri Yükle
                </h2>
                <p className="text-gray-400 mb-4">
                  Daha önce oluşturduğunuz bir yedek dosyasını yükleyerek tüm verileri geri yükleyin.
                </p>
                <div className="bg-yellow-900/30 border border-yellow-600/50 rounded-lg p-4 mb-4">
                  <p className="text-yellow-400 text-sm flex items-center gap-2">
                    <AlertTriangle className="w-5 h-5" />
                    <strong>DİKKAT:</strong> Geri yükleme işlemi mevcut verilerin üzerine yazacaktır!
                  </p>
                </div>
                <input
                  ref={backupFileInputRef}
                  type="file"
                  accept=".json"
                  onChange={handleRestoreBackup}
                  className="hidden"
                  id="backup-file-input"
                />
                <button
                  onClick={() => backupFileInputRef.current?.click()}
                  disabled={restoreLoading}
                  className="px-6 py-3 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 rounded-lg font-semibold flex items-center gap-2"
                >
                  {restoreLoading ? (
                    <>
                      <RefreshCw className="w-5 h-5 animate-spin" />
                      Geri Yükleniyor...
                    </>
                  ) : (
                    <>
                      <Upload className="w-5 h-5" />
                      Yedek Dosyası Seç ve Geri Yükle
                    </>
                  )}
                </button>
              </div>
              
              {/* Sonuç Mesajı */}
              {backupResult && (
                <div className={`rounded-lg p-4 ${backupResult.success ? 'bg-green-900/30 border border-green-600/50' : 'bg-red-900/30 border border-red-600/50'}`}>
                  <p className={backupResult.success ? 'text-green-400' : 'text-red-400'}>
                    {backupResult.success ? '✅' : '❌'} {backupResult.message}
                  </p>
                </div>
              )}
              
              {/* Bilgi Notu */}
              <div className="bg-gray-800 rounded-lg p-6">
                <h3 className="font-semibold mb-2 flex items-center gap-2">
                  <HelpCircle className="w-5 h-5 text-gray-400" />
                  Bilgi
                </h3>
                <ul className="text-sm text-gray-400 space-y-2">
                  <li>• Yedek dosyası JSON formatındadır ve bilgisayarınıza indirilir.</li>
                  <li>• GitHub'a push yapmadan önce yedek almanız önerilir.</li>
                  <li>• Kullanıcı şifreleri güvenlik nedeniyle yedeklenmez.</li>
                  <li>• Geri yükleme sonrası mevcut kullanıcılar şifrelerini korur.</li>
                </ul>
              </div>
            </div>
          )}

          {/* Open Positions Tab */}
          {activeTab === 'positions' && <OpenPositionsManagement />}

          {/* Manipulate Tab */}
          {activeTab === 'manipulate' && <div className="text-gray-400 p-4">Bu panel kaldırıldı (Paket 3).</div>}
          {activeTab === 'discovery' && <DiscoveryPanel />}

          {/* Support Tickets Tab */}
          {activeTab === 'support-tickets' && (
            <div className="flex gap-2 sm:p-4 h-full">
              {/* Tickets List */}
              <div className="w-96 bg-gray-800 rounded-lg p-2 sm:p-4">
                <h2 className="text-lg sm:text-xl font-bold mb-4">💬 Destek Talepleri</h2>
                
                {supportTickets.length === 0 ? (
                  <div className="text-center text-gray-400 py-8">
                    <div className="text-4xl mb-2">💬</div>
                    <div>Destek talebi yok</div>
                  </div>
                ) : (
                  <div className="space-y-2">
                    {supportTickets.map((ticket) => (
                      <button
                        key={ticket.id}
                        onClick={() => fetchTicketDetails(ticket.id)}
                        className={`w-full text-left p-3 rounded-lg transition-colors ${
                          selectedTicket?.id === ticket.id
                            ? 'bg-blue-600'
                            : 'bg-gray-700 hover:bg-gray-600'
                        }`}
                      >
                        <div className="flex items-center justify-between mb-1">
                          <div className="font-semibold truncate flex-1">{ticket.subject}</div>
                          <span className={`px-2 py-0.5 rounded text-xs ${
                            ticket.status === 'OPEN' ? 'bg-green-600' :
                            ticket.status === 'IN_PROGRESS' ? 'bg-yellow-600' :
                            'bg-gray-600'
                          }`}>
                            {ticket.status}
                          </span>
                        </div>
                        <div className="text-xs text-gray-400">{ticket.user_email}</div>
                        <div className="text-xs text-gray-500 mt-1">
                          {new Date(ticket.created_at).toLocaleDateString('tr-TR')}
                        </div>
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Ticket Details */}
              <div className="flex-1 bg-gray-800 rounded-lg flex flex-col">
                {selectedTicket ? (
                  <>
                    {/* Header */}
                    <div className="p-2 sm:p-4 border-b border-gray-700">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="text-base sm:text-lg font-bold">{selectedTicket.subject}</h3>
                        <div className="flex gap-2">
                          <button
                            onClick={() => handleUpdateTicketStatus(selectedTicket.id, 'IN_PROGRESS')}
                            className="px-3 py-1 bg-yellow-600 hover:bg-yellow-700 rounded text-xs"
                          >
                            İşlemde
                          </button>
                          <button
                            onClick={() => handleUpdateTicketStatus(selectedTicket.id, 'CLOSED')}
                            className="px-3 py-1 bg-gray-600 hover:bg-gray-700 rounded text-xs"
                          >
                            Kapat
                          </button>
                        </div>
                      </div>
                      <div className="text-sm text-gray-400">
                        Kullanıcı: {selectedTicket.user_email} • Ticket ID: {selectedTicket.id.substring(0, 8)}
                      </div>
                    </div>

                    {/* Messages */}
                    <div className="flex-1 overflow-y-auto p-2 sm:p-4 space-y-3">
                      {ticketMessages.map((message) => (
                        <div
                          key={message.id}
                          className={`flex ${message.sender_role === 'ADMIN' ? 'justify-end' : 'justify-start'}`}
                        >
                          <div
                            className={`max-w-md rounded-lg p-3 ${
                              message.sender_role === 'ADMIN'
                                ? 'bg-blue-600'
                                : 'bg-gray-700'
                            }`}
                          >
                            <div className="text-xs text-gray-300 mb-1">
                              {message.sender_role === 'ADMIN' ? 'Admin' : message.sender_email}
                            </div>
                            <div className="text-sm">{message.message}</div>
                            <div className="text-xs text-gray-400 mt-1">
                              {new Date(message.created_at).toLocaleString('tr-TR')}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Reply Input */}
                    {selectedTicket.status !== 'CLOSED' && (
                      <div className="p-2 sm:p-4 border-t border-gray-700">
                        <div className="flex gap-2">
                          <input
                            type="text"
                            value={adminReply}
                            onChange={(e) => setAdminReply(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleSendAdminReply()}
                            placeholder="Cevabınızı yazın..."
                            className="flex-1 bg-gray-700 border border-gray-600 rounded px-3 py-2"
                          />
                          <button
                            onClick={handleSendAdminReply}
                            disabled={loading}
                            className="px-3 sm:px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 rounded font-semibold"
                          >
                            📤 Gönder
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex-1 flex items-center justify-center text-gray-400">
                    <div className="text-center">
                      <div className="text-6xl mb-4">💬</div>
                      <div className="text-lg">Bir destek talebi seçin</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Assets Tab */}
          {activeTab === 'assets' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Varlık Yönetimi</h2>
              
              {/* Create Asset Form */}
              <div className="bg-gray-800 p-2 sm:p-4 rounded-lg mb-6">
                <h3 className="text-base sm:text-lg font-bold mb-4">Yeni Varlık Ekle</h3>
                <form onSubmit={handleCreateAsset} className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:p-4">
                    <div>
                      <label className="block text-gray-300 mb-2 text-sm">Sembol</label>
                      <input
                        type="text"
                        value={newAsset.symbol}
                        onChange={(e) => setNewAsset({...newAsset, symbol: e.target.value.toUpperCase()})}
                        placeholder="AKBNK"
                        required
                        className="w-full bg-gray-700 border-gray-600 rounded px-3 py-2"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-300 mb-2 text-sm">İsim</label>
                      <input
                        type="text"
                        value={newAsset.name}
                        onChange={(e) => setNewAsset({...newAsset, name: e.target.value})}
                        placeholder="Akbank"
                        required
                        className="w-full bg-gray-700 border-gray-600 rounded px-3 py-2"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-300 mb-2 text-sm">Kategori</label>
                      <select
                        value={newAsset.category}
                        onChange={(e) => setNewAsset({...newAsset, category: e.target.value})}
                        required
                        className="w-full bg-gray-700 border-gray-600 rounded px-3 py-2"
                      >
                        {CATEGORIES.map(cat => (
                          <option key={cat} value={cat}>{cat}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-gray-300 mb-2 text-sm">Başlangıç Fiyatı (TL)</label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={newAsset.current_price}
                        onChange={(e) => setNewAsset({...newAsset, current_price: e.target.value})}
                        placeholder="50.25"
                        required
                        className="w-full bg-gray-700 border-gray-600 rounded px-3 py-2"
                      />
                    </div>
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="px-3 sm:px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded font-semibold"
                  >
                    {loading ? 'Ekleniyor...' : 'Varlık Ekle'}
                  </button>
                </form>
              </div>

              {/* Toplu Fiyat Güncelleme */}
              <div className="bg-gray-800 p-4 rounded-lg mb-4">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <span className="text-gray-300 font-semibold">Toplu Fiyat Güncelle:</span>
                  
                  <select
                    value={selectedAssetCategory}
                    onChange={(e) => setSelectedAssetCategory(e.target.value)}
                    className="bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                  >
                    <option value="BIST_100">BIST 100</option>
                    <option value="VIOP">VIOP</option>
                    <option value="EMTIA">Emtia</option>
                    <option value="KRIPTO">Kripto</option>
                    <option value="DOVIZ">Döviz</option>
                    <option value="ENDEKSLER">Endeksler</option>
                    <option value="ABD_NASDAQ">ABD/NASDAQ</option>
                    <option value="ALL">Tümü</option>
                  </select>
                  
                  <button
                    onClick={() => handleSyncPrices(selectedAssetCategory)}
                    disabled={syncingPrices}
                    className={`px-4 py-2 rounded font-semibold flex items-center gap-2 ${
                      syncingPrices 
                        ? 'bg-gray-600 cursor-not-allowed' 
                        : 'bg-green-600 hover:bg-green-700'
                    }`}
                  >
                    {syncingPrices ? (
                      <>
                        <span className="animate-spin">⏳</span>
                        Güncelleniyor...
                      </>
                    ) : (
                      <>
                        Fiyatları Güncelle
                      </>
                    )}
                  </button>
                  
                  <span className="text-xs text-gray-500">
                    (Anlık fiyatları ve kapanışları günceller)
                  </span>
                </div>
                
                {/* API'den Toplu Güncelleme */}
                <div className="flex flex-wrap items-center gap-3 pt-3 border-t border-gray-700">
                  <span className="text-gray-300 font-semibold">🌐 Fiyat Güncelle:</span>
                  
                  <button
                    onClick={() => handleBulkUpdateFromAPI([selectedAssetCategory === 'ALL' ? '' : selectedAssetCategory].filter(Boolean))}
                    disabled={bulkUpdating}
                    className={`px-4 py-2 rounded font-semibold flex items-center gap-2 ${
                      bulkUpdating 
                        ? 'bg-gray-600 cursor-not-allowed' 
                        : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                  >
                    {bulkUpdating ? (
                      <>
                        <span className="animate-spin">⏳</span>
                        Güncelleniyor...
                      </>
                    ) : (
                      <>
                        Seçili Kategoriyi Güncelle
                      </>
                    )}
                  </button>
                  
                  <button
                    onClick={() => handleBulkUpdateFromAPI([])}
                    disabled={bulkUpdating}
                    className={`px-4 py-2 rounded font-semibold flex items-center gap-2 ${
                      bulkUpdating 
                        ? 'bg-gray-600 cursor-not-allowed' 
                        : 'bg-purple-600 hover:bg-purple-700'
                    }`}
                  >
                    {bulkUpdating ? (
                      <>
                        <span className="animate-spin">⏳</span>
                        Güncelleniyor...
                      </>
                    ) : (
                      <>
                        TÜM KATEGORİLERİ Güncelle
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* Search Box */}
              <div className="bg-gray-800 p-4 rounded-lg mb-4">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="🔍 Varlık ara (sembol veya isim)..."
                  className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-2 text-white placeholder-gray-400"
                />
              </div>

              {/* Assets Table */}
              <div className="bg-gray-800 rounded-lg overflow-x-auto">
                <div className="px-4 py-2 bg-gray-700 text-sm text-gray-300">
                  Toplam {assets.filter(asset => 
                    asset.symbol.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    asset.name.toLowerCase().includes(searchQuery.toLowerCase())
                  ).length} / {assets.length} varlık
                </div>
                <table className="w-full text-sm">
                  <thead className="bg-gray-700">
                    <tr>
                      <th className="px-4 py-3 text-left">Sembol</th>
                      <th className="px-4 py-3 text-left">İsim</th>
                      <th className="px-4 py-3 text-left">Kategori</th>
                      <th className="px-4 py-3 text-left">Fiyat</th>
                      <th className="px-4 py-3 text-left">Değişim</th>
                      <th className="px-4 py-3 text-left">Kaynak</th>
                      <th className="px-4 py-3 text-left">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assets
                      .filter(asset => 
                        asset.symbol.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        asset.name.toLowerCase().includes(searchQuery.toLowerCase())
                      )
                      .map(asset => (
                      <tr key={asset.id} className="border-t border-gray-700">
                        <td className="px-4 py-3 font-bold">{asset.symbol}</td>
                        <td className="px-4 py-3">{asset.name}</td>
                        <td className="px-4 py-3">
                          <span className="px-2 py-1 bg-gray-700 rounded text-xs">
                            {asset.category}
                          </span>
                        </td>
                        <td className="px-4 py-3 font-mono">
                          {(asset.current_price || 0).toLocaleString('tr-TR', {minimumFractionDigits: 2})} TL
                        </td>
                        <td className={`px-4 py-3 ${(asset.change_percent || 0) >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                          {(asset.change_percent || 0) >= 0 ? '+' : ''}{(asset.change_percent || 0).toFixed(2)}%
                        </td>
                        <td className="px-4 py-3">
                          {asset.is_mock ? (
                            <span className="text-yellow-400 text-xs">Mock</span>
                          ) : (
                            <span className="text-green-400 text-xs">API</span>
                          )}
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex gap-2">
                            <button
                              onClick={() => handleOpenEditAsset(asset)}
                              className="px-3 py-1 bg-purple-600 hover:bg-purple-700 rounded text-xs"
                            >
                              ✏️ Düzenle
                            </button>
                            <button
                              onClick={() => handleDeleteAsset(asset.id)}
                              className="px-3 py-1 bg-red-600 hover:bg-red-700 rounded text-xs"
                            >
                              🗑️ Sil
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Documents Tab */}
          {activeTab === 'documents' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Belge Onayları</h2>
              
              <div className="bg-gray-800 rounded-lg overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className="bg-gray-700">
                    <tr>
                      <th className="px-4 py-3 text-left">Kullanıcı</th>
                      <th className="px-4 py-3 text-left">Ad Soyad</th>
                      <th className="px-4 py-3 text-left">Belge Tipi</th>
                      <th className="px-4 py-3 text-left">Durum</th>
                      <th className="px-4 py-3 text-left">Yüklenme</th>
                      <th className="px-4 py-3 text-right">İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="px-4 py-8 text-center text-gray-400">
                          Henüz belge yüklenmemiş
                        </td>
                      </tr>
                    ) : (
                      documents.map(doc => (
                        <tr key={doc.id} className="border-t border-gray-700 hover:bg-gray-750">
                          <td className="px-4 py-3">
                            <div className="font-mono text-xs text-gray-400">{doc.user_id}</div>
                            <div className="text-sm">{doc.user_email}</div>
                          </td>
                          <td className="px-4 py-3">{doc.user_full_name || '-'}</td>
                          <td className="px-4 py-3">
                            <span className="px-2 py-1 bg-blue-900/50 text-blue-300 rounded text-xs">
                              {doc.document_type}
                            </span>
                          </td>
                          <td className="px-4 py-3">
                            <span className={`px-2 py-1 rounded text-xs ${
                              doc.status === 'APPROVED' ? 'bg-green-900/50 text-green-300' :
                              doc.status === 'REJECTED' ? 'bg-red-900/50 text-red-300' :
                              doc.status === 'REVIEWING' ? 'bg-yellow-900/50 text-yellow-300' :
                              'bg-gray-700 text-gray-300'
                            }`}>
                              {doc.status === 'PENDING' ? 'Bekleniyor' :
                               doc.status === 'REVIEWING' ? 'İnceleniyor' :
                               doc.status === 'APPROVED' ? 'Onaylandı' :
                               'Reddedildi'}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-xs text-gray-400">
                            {new Date(doc.uploaded_at).toLocaleString('tr-TR')}
                          </td>
                          <td className="px-4 py-3 text-right space-x-2">
                            <a
                              href={doc.file_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="inline-block px-3 py-1 bg-blue-600 hover:bg-blue-700 rounded text-xs"
                            >
                              Görüntüle
                            </a>
                            {doc.status === 'PENDING' || doc.status === 'REVIEWING' ? (
                              <>
                                <button
                                  onClick={() => handleApproveDocument(doc.id)}
                                  className="px-3 py-1 bg-green-600 hover:bg-green-700 rounded text-xs"
                                >
                                  Onayla
                                </button>
                                <button
                                  onClick={() => handleRejectDocument(doc.id)}
                                  className="px-3 py-1 bg-red-600 hover:bg-red-700 rounded text-xs"
                                >
                                  Reddet
                                </button>
                              </>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Telegram Settings Tab */}
          {/* Broker Management */}
          {activeTab === 'brokers' && (
            <div>
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold">🏦 Aracı Kurum Yönetimi</h2>
                <button
                  onClick={() => openBrokerModal()}
                  className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-semibold flex items-center gap-2"
                >
                  <span>➕</span>
                  Yeni Aracı Kurum Ekle
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:p-6">
                {brokers.map((broker) => (
                  <div key={broker.id} className="bg-gray-800 rounded-lg overflow-hidden border border-gray-700">
                    {/* Logo Preview */}
                    <div className="bg-white p-3 sm:p-6 flex items-center justify-center h-32">
                      {broker.logo_url ? (
                        <img 
                          src={getFullAssetUrl(broker.logo_url)}
                          alt={broker.name}
                          className="max-w-full max-h-full object-contain"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                      ) : null}
                      <div 
                        className={`text-2xl font-bold ${broker.logo_url ? 'hidden' : 'block'}`}
                        style={{ color: broker.color }}
                      >
                        {broker.name}
                      </div>
                    </div>

                    {/* Info */}
                    <div className="p-2 sm:p-4">
                      <h3 className="text-base sm:text-lg font-bold mb-2">{broker.name}</h3>
                      <div className="space-y-2 text-sm">
                        <div className="flex items-center gap-2">
                          <span className="text-gray-400">Renk:</span>
                          <div 
                            className="w-6 h-6 rounded border border-gray-600"
                            style={{ backgroundColor: broker.color }}
                          ></div>
                          <span className="font-mono text-xs">{broker.color}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-gray-400">Logo:</span>
                          <span className="text-xs text-gray-500 truncate flex-1">
                            {broker.logo_url || 'Yok'}
                          </span>
                        </div>
                        {broker.spk_doc_url && (
                          <div className="flex items-center gap-2">
                            <span className="text-gray-400">SPK:</span>
                            <a 
                              href={broker.spk_doc_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-400 hover:underline text-xs"
                            >
                              Belge Görüntüle
                            </a>
                          </div>
                        )}
                      </div>

                      {/* Actions */}
                      <div className="flex flex-col gap-2 mt-4">
                        <button
                          onClick={() => handleSetHomepage(broker.id)}
                          className={`py-2 rounded text-sm font-semibold ${
                            broker.is_homepage 
                              ? 'bg-green-600 text-white cursor-default'
                              : 'bg-purple-600 hover:bg-purple-700 text-white'
                          }`}
                          disabled={broker.is_homepage}
                        >
                          {broker.is_homepage ? '✅ Ana Sayfa' : '🏠 Ana Sayfa Yap'}
                        </button>
                        <button
                          onClick={() => openLandingPageEditor(broker)}
                          className="py-2 bg-cyan-600 hover:bg-cyan-700 rounded text-sm font-semibold text-white"
                        >
                          📝 Landing Page Düzenle
                        </button>
                        <div className="flex gap-2">
                          <button
                            onClick={() => openBrokerModal(broker)}
                            className="flex-1 py-2 bg-blue-600 hover:bg-blue-700 rounded text-sm"
                          >
                            Düzenle
                          </button>
                          <button
                            onClick={() => handleDeleteBroker(broker.id)}
                            className="flex-1 py-2 bg-red-600 hover:bg-red-700 rounded text-sm"
                          >
                            Sil
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {brokers.length === 0 && (
                <div className="bg-gray-800 rounded-lg p-12 text-center text-gray-400">
                  Henüz aracı kurum eklenmemiş. Yeni ekle butonuna tıklayın.
                </div>
              )}
            </div>
          )}

          {/* IBAN Settings Tab */}
          {/* Crypto Settings */}
          {activeTab === 'crypto-settings' && <CryptoSettings />}

          {activeTab === 'settings' && (
            <div>
              {/* Çoklu Banka Hesapları Yönetimi */}
              <div>
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-2xl font-bold">Banka Hesapları Yönetimi</h2>
                  <button
                    onClick={() => setShowAddBankModal(true)}
                    className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg font-semibold flex items-center gap-2"
                  >
                    <span>➕</span>
                    Yeni Banka Ekle
                  </button>
                </div>

                {/* Mevcut Banka Hesapları */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {bankAccounts.map((account) => (
                    <div key={account.id} className={`bg-gray-800 rounded-lg p-4 border-2 ${account.is_active ? 'border-green-500' : 'border-gray-600'}`}>
                      <div className="flex items-center gap-3 mb-3">
                        {/* Logo veya Renkli Kısaltma */}
                        {account.bank_logo ? (
                          <img 
                            src={account.bank_logo} 
                            alt={account.bank_name}
                            className="w-12 h-12 object-contain rounded-lg"
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        ) : (
                          <div 
                            className="w-12 h-12 rounded-lg flex items-center justify-center font-bold text-white text-lg shadow-lg"
                            style={{ backgroundColor: account.bank_color || '#333' }}
                          >
                            {account.bank_short || account.bank_name?.substring(0, 2).toUpperCase()}
                          </div>
                        )}
                        <div>
                          <h4 className="font-bold text-white">{account.bank_name}</h4>
                          <span className={`text-xs px-2 py-0.5 rounded ${account.is_active ? 'bg-green-600' : 'bg-gray-600'}`}>
                            {account.is_active ? 'Aktif' : 'Pasif'}
                          </span>
                        </div>
                      </div>
                      <div className="space-y-1 text-sm">
                        <p className="text-gray-400">Hesap Sahibi:</p>
                        <p className="text-white font-medium">{account.account_holder}</p>
                        <p className="text-gray-400 mt-2">IBAN:</p>
                        <p className="text-white font-mono text-xs break-all">{account.iban}</p>
                      </div>
                      <div className="flex gap-2 mt-4">
                        <button
                          onClick={() => handleToggleBankAccount(account)}
                          className={`flex-1 py-2 rounded text-sm font-semibold transition-colors ${account.is_active ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-green-600 hover:bg-green-700'}`}
                        >
                          {account.is_active ? '⏸️ Pasif Yap' : '▶️ Aktif Yap'}
                        </button>
                        {deleteConfirmId === account.id ? (
                          <div className="flex gap-1">
                            <button
                              onClick={() => handleDeleteBankAccount(account.id)}
                              className="px-3 py-2 bg-red-700 hover:bg-red-800 rounded text-sm font-semibold animate-pulse"
                            >
                              ✓ Sil
                            </button>
                            <button
                              onClick={() => setDeleteConfirmId(null)}
                              className="px-3 py-2 bg-gray-600 hover:bg-gray-700 rounded text-sm font-semibold"
                            >
                              ✕
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => handleDeleteBankAccount(account.id)}
                            className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded text-sm font-semibold"
                          >
                            🗑️
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                {bankAccounts.length === 0 && (
                  <div className="bg-red-900/30 border-2 border-red-600 rounded-lg p-8 text-center">
                    <div className="text-5xl mb-4"></div>
                    <p className="text-red-400 text-lg font-bold">Aktif IBAN Bilgisi Eklenmedi!</p>
                    <p className="text-gray-400 text-sm mt-2">Kullanıcılar para yatırma sayfasında banka bilgisi göremeyecek.</p>
                    <button
                      onClick={() => setShowAddBankModal(true)}
                      className="mt-4 px-6 py-3 bg-green-600 hover:bg-green-700 rounded-lg font-semibold"
                    >
                      ➕ İlk Bankayı Ekle
                    </button>
                  </div>
                )}

                {bankAccounts.length > 0 && bankAccounts.filter(b => b.is_active).length === 0 && (
                  <div className="bg-yellow-900/30 border-2 border-yellow-600 rounded-lg p-6 text-center mt-4">
                    <div className="text-4xl mb-3">⚠️</div>
                    <p className="text-yellow-400 font-bold">Tüm Bankalar Pasif Durumda!</p>
                    <p className="text-gray-400 text-sm mt-1">Kullanıcılar para yatırma sayfasında banka bilgisi göremeyecek.</p>
                  </div>
                )}
              </div>

              {/* Banka Ekleme Modal */}
              {showAddBankModal && (
                <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[100] p-4" onClick={(e) => e.target === e.currentTarget && setShowAddBankModal(false)}>
                  <div className="bg-gray-800 rounded-lg max-w-lg w-full p-6 relative z-[101]" onClick={(e) => e.stopPropagation()}>
                    <h3 className="text-xl font-bold mb-4">🏦 Yeni Banka Hesabı Ekle</h3>
                    
                    <div className="space-y-4">
                      {/* Banka Seçimi */}
                      <div>
                        <label className="block text-sm font-semibold mb-2 text-gray-300">Banka Seç</label>
                        <div className="grid grid-cols-3 gap-2 max-h-48 overflow-y-auto p-1">
                          {availableBanks.map((bank) => (
                            <button
                              key={bank.code}
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setNewBankAccount({...newBankAccount, bank_code: bank.code});
                              }}
                              className={`p-2 rounded-lg border-2 flex flex-col items-center gap-1 cursor-pointer transition-all ${newBankAccount.bank_code === bank.code ? 'border-blue-500 bg-blue-900/30 ring-2 ring-blue-400' : 'border-gray-600 hover:border-gray-500 hover:bg-gray-700'}`}
                            >
                              {/* Logo veya Renkli Kısaltma */}
                              <div className="w-10 h-10 rounded-lg flex items-center justify-center overflow-hidden pointer-events-none">
                                <img 
                                  src={bank.logo} 
                                  alt={bank.name}
                                  className="w-full h-full object-contain"
                                  onError={(e) => {
                                    // Logo yüklenemezse gizle ve fallback göster
                                    e.target.style.display = 'none';
                                    e.target.nextElementSibling.style.display = 'flex';
                                  }}
                                />
                                <div 
                                  className="w-full h-full rounded-lg items-center justify-center font-bold text-white text-sm shadow hidden"
                                  style={{ backgroundColor: bank.color || '#333' }}
                                >
                                  {bank.short || bank.name?.substring(0, 2).toUpperCase()}
                                </div>
                              </div>
                              <span className="text-xs text-center pointer-events-none">{bank.name}</span>
                            </button>
                          ))}
                        </div>
                        {newBankAccount.bank_code && (
                          <p className="text-green-400 text-sm mt-2">✅ Seçilen: {availableBanks.find(b => b.code === newBankAccount.bank_code)?.name}</p>
                        )}
                      </div>

                      {/* Hesap Sahibi */}
                      <div>
                        <label className="block text-sm font-semibold mb-2 text-gray-300">Hesap Sahibi</label>
                        <input
                          type="text"
                          value={newBankAccount.account_holder}
                          onChange={(e) => setNewBankAccount({...newBankAccount, account_holder: e.target.value})}
                          className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white"
                          placeholder="Örn: AHMET YILMAZ"
                        />
                      </div>

                      {/* IBAN */}
                      <div>
                        <label className="block text-sm font-semibold mb-2 text-gray-300">IBAN</label>
                        <input
                          type="text"
                          value={newBankAccount.iban}
                          onChange={(e) => setNewBankAccount({...newBankAccount, iban: e.target.value})}
                          className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white font-mono"
                          placeholder="TR00 0000 0000 0000 0000 0000 00"
                        />
                      </div>
                    </div>

                    <div className="flex gap-3 mt-6">
                      <button
                        type="button"
                        onClick={() => {
                          setShowAddBankModal(false);
                          setNewBankAccount({ bank_code: '', account_holder: '', iban: '' });
                        }}
                        className="flex-1 py-3 bg-gray-600 hover:bg-gray-700 rounded-lg font-semibold transition-colors"
                      >
                        ❌ İptal
                      </button>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          handleAddBankAccount();
                        }}
                        disabled={!newBankAccount.bank_code || !newBankAccount.iban}
                        className={`flex-1 py-3 rounded-lg font-semibold transition-colors ${
                          newBankAccount.bank_code && newBankAccount.iban 
                            ? 'bg-green-600 hover:bg-green-700' 
                            : 'bg-gray-500 cursor-not-allowed'
                        }`}
                      >
                        ✅ Ekle
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Broker Modal */}
          {showBrokerModal && (
            <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-2 sm:p-4">
              <div className="bg-gray-800 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="p-3 sm:p-6">
                  <h3 className="text-2xl font-bold mb-6">
                    {editingBroker ? 'Aracı Kurum Düzenle' : 'Yeni Aracı Kurum Ekle'}
                  </h3>

                  <div className="space-y-4">
                    <div>
                      <label className="block text-gray-300 mb-2 font-semibold">
                        Kurum Adı *
                      </label>
                      <input
                        type="text"
                        value={brokerForm.name}
                        onChange={(e) => setBrokerForm({...brokerForm, name: e.target.value})}
                        placeholder="Örn: Tacirler Yatırım"
                        className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-300 mb-2 font-semibold">
                        Logo *
                      </label>
                      
                      {/* File Upload */}
                      <div className="mb-3">
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/png,image/jpeg,image/jpg,image/svg+xml"
                          onChange={handleLogoUpload}
                          className="hidden"
                          disabled={uploadingLogo}
                        />
                        <button
                          type="button"
                          onClick={() => fileInputRef.current?.click()}
                          disabled={uploadingLogo}
                          className="flex items-center justify-center w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 rounded cursor-pointer transition-colors"
                        >
                          <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                          </svg>
                          {uploadingLogo ? 'Yükleniyor...' : 'Bilgisayardan Logo Yükle (PNG/JPG/SVG)'}
                        </button>
                        <p className="text-xs text-gray-400 mt-1">
                          Maksimum 5MB, şeffaf arka plan desteklenir
                        </p>
                      </div>
                      
                      {/* Divider */}
                      <div className="flex items-center gap-3 my-3">
                        <div className="flex-1 border-t border-gray-600"></div>
                        <span className="text-gray-400 text-sm">veya</span>
                        <div className="flex-1 border-t border-gray-600"></div>
                      </div>
                      
                      {/* URL Input */}
                      <input
                        type="text"
                        value={brokerForm.logo_url}
                        onChange={(e) => setBrokerForm({...brokerForm, logo_url: e.target.value})}
                        placeholder="https://example.com/logo.png"
                        className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
                      />
                      <p className="text-xs text-gray-400 mt-1">
                        Logo URL'si manuel olarak girilebilir
                      </p>
                    </div>

                    <div>
                      <label className="block text-gray-300 mb-2 font-semibold">
                        Renk Kodu *
                      </label>
                      <div className="flex gap-2">
                        <input
                          type="color"
                          value={brokerForm.color}
                          onChange={(e) => setBrokerForm({...brokerForm, color: e.target.value})}
                          className="w-16 h-12 bg-gray-700 border border-gray-600 rounded cursor-pointer"
                        />
                        <input
                          type="text"
                          value={brokerForm.color}
                          onChange={(e) => setBrokerForm({...brokerForm, color: e.target.value})}
                          placeholder="#003087"
                          className="flex-1 bg-gray-700 border border-gray-600 rounded px-4 py-3 font-mono"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-gray-300 mb-2 font-semibold">
                        TSPB Belge URL
                      </label>
                      <input
                        type="text"
                        value={brokerForm.spk_doc_url}
                        onChange={(e) => setBrokerForm({...brokerForm, spk_doc_url: e.target.value})}
                        placeholder="https://tspb.org.tr/wp-content/uploads/..."
                        className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
                      />
                      <p className="text-xs text-gray-400 mt-1">
                        TSPB kamuyu aydınlatma belgesi PDF linki
                      </p>
                    </div>

                    {/* Preview */}
                    {brokerForm.logo_url && (
                      <div>
                        <label className="block text-gray-300 mb-2 font-semibold">
                          Önizleme
                        </label>
                        <div className="bg-white rounded-lg p-2 sm:p-4 flex items-center justify-center h-32">
                          <img 
                            src={brokerForm.logo_url} 
                            alt="Preview"
                            className="max-w-full max-h-full object-contain"
                            onError={(e) => e.target.src = ''}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="flex gap-3 mt-6">
                    <button
                      onClick={editingBroker ? handleUpdateBroker : handleCreateBroker}
                      className="flex-1 py-3 bg-blue-600 hover:bg-blue-700 rounded font-semibold"
                    >
                      {editingBroker ? 'Güncelle' : 'Ekle'}
                    </button>
                    <button
                      onClick={() => {
                        setShowBrokerModal(false);
                        setEditingBroker(null);
                        setBrokerForm({ name: '', logo_url: '', color: '#003087', spk_doc_url: '' });
                      }}
                      className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 rounded"
                    >
                      İptal
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'telegram' && (
            <div>
              <h2 className="text-2xl font-bold mb-6">Telegram Ayarları</h2>
              
              <div className="bg-gray-800 rounded-lg p-3 sm:p-6 max-w-2xl">
                <div className="space-y-6">
                  <div>
                    <label className="block text-gray-300 mb-2 font-semibold">
                      Telegram Bot Token
                    </label>
                    <input
                      type="text"
                      value={telegramSettings.bot_token}
                      onChange={(e) => setTelegramSettings({...telegramSettings, bot_token: e.target.value})}
                      placeholder="123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11"
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
                    />
                    <p className="text-xs text-gray-400 mt-2">
                      BotFather'dan aldığınız bot token'ını girin
                    </p>
                  </div>

                  <div>
                    <label className="block text-gray-300 mb-2 font-semibold">
                      Chat ID
                    </label>
                    <input
                      type="text"
                      value={telegramSettings.chat_id}
                      onChange={(e) => setTelegramSettings({...telegramSettings, chat_id: e.target.value})}
                      placeholder="-1001234567890"
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
                    />
                    <p className="text-xs text-gray-400 mt-2">
                      Bildirimlerin gönderileceği grup veya kanal ID'si
                    </p>
                  </div>

                  <div>
                    <label className="block text-gray-300 mb-2 font-semibold">
                      💬 WhatsApp Destek
                    </label>
                    <div className="flex items-center justify-between bg-gray-700 border border-gray-600 rounded px-4 py-3">
                      <span className="text-gray-300">
                        {telegramSettings.whatsapp_enabled ? 'Aktif' : 'Pasif'}
                      </span>
                      <button
                        onClick={() => setTelegramSettings({...telegramSettings, whatsapp_enabled: !telegramSettings.whatsapp_enabled})}
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                          telegramSettings.whatsapp_enabled ? 'bg-green-600' : 'bg-gray-600'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            telegramSettings.whatsapp_enabled ? 'translate-x-6' : 'translate-x-1'
                          }`}
                        />
                      </button>
                    </div>
                    <p className="text-xs text-gray-400 mt-2">
                      Aktif olduğunda destek sayfasında WhatsApp butonu görünür
                    </p>
                  </div>

                  {telegramSettings.whatsapp_enabled && (
                    <div>
                      <label className="block text-gray-300 mb-2 font-semibold">
                        📱 WhatsApp Numarası
                      </label>
                      <input
                        type="text"
                        value={telegramSettings.whatsapp_number}
                        onChange={(e) => setTelegramSettings({...telegramSettings, whatsapp_number: e.target.value})}
                        placeholder="905551234567"
                        className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
                      />
                      <p className="text-xs text-gray-400 mt-2">
                        90 ile başlayarak, boşluksuz girin (örn: 905551234567)
                      </p>
                    </div>
                  )}

                  <div className="bg-blue-900/20 border border-blue-700 rounded p-2 sm:p-4">
                    <h3 className="font-semibold text-blue-300 mb-2">ℹ️ Nasıl Alınır?</h3>
                    <ol className="text-sm text-gray-300 space-y-1 list-decimal list-inside">
                      <li>Telegram'da @BotFather'a mesaj gönderin</li>
                      <li>/newbot komutuyla yeni bot oluşturun</li>
                      <li>Bot token'ı kopyalayın</li>
                      <li>@userinfobot'a mesaj göndererek Chat ID'nizi alın</li>
                      <li>WhatsApp numaranızı 90 ile başlayarak girin (örn: 905551234567)</li>
                    </ol>
                  </div>

                  <button
                    onClick={handleSaveTelegramSettings}
                    className="w-full py-3 bg-green-600 hover:bg-green-700 rounded font-semibold"
                  >
                    💾 Kaydet
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Live Support Tab */}
          {activeTab === 'live-chat' && (
            <div>
              <AdminLiveChat user={user} />
            </div>
          )}

          {/* News Tab */}
          {activeTab === 'news' && (
            <div>
              <AdminNews user={user} />
            </div>
          )}

          {activeTab === 'notifications' && (
            <div className="space-y-6">
              <div className="bg-gray-800 rounded-lg p-6">
                <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
                  Bildirim Gönder
                </h2>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-gray-300 mb-2">Başlık</label>
                    <input
                      type="text"
                      value={notificationForm.title}
                      onChange={(e) => setNotificationForm({ ...notificationForm, title: e.target.value })}
                      placeholder="Bildirim başlığı"
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3 text-white"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-300 mb-2">Mesaj</label>
                    <textarea
                      value={notificationForm.message}
                      onChange={(e) => setNotificationForm({ ...notificationForm, message: e.target.value })}
                      placeholder="Bildirim mesajı"
                      rows={5}
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3 text-white"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-300 mb-2">Bildirim Tipi</label>
                    <select
                      value={notificationForm.type}
                      onChange={(e) => setNotificationForm({ ...notificationForm, type: e.target.value })}
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3 text-white"
                    >
                      <option value="info">ℹ️ Bilgi (Mavi)</option>
                      <option value="success">✅ Başarılı (Yeşil)</option>
                      <option value="warning">⚠️ Uyarı (Sarı)</option>
                      <option value="danger">🚨 Tehlike (Kırmızı)</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-gray-300 mb-2">Hedef Kullanıcı</label>
                    <select
                      value={notificationForm.user_id || ''}
                      onChange={(e) => setNotificationForm({ 
                        ...notificationForm, 
                        user_id: e.target.value === 'all' ? null : e.target.value 
                      })}
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3 text-white"
                    >
                      <option value="all">📢 Tüm Kullanıcılara Gönder</option>
                      {users.map(user => (
                        <option key={user.id} value={user.id}>
                          {user.email} - {user.full_name || 'İsimsiz'}
                        </option>
                      ))}
                    </select>
                  </div>

                  <button
                    onClick={async () => {
                      if (!notificationForm.title || !notificationForm.message) {
                        setNotificationResult({ success: false, message: '❌ Lütfen başlık ve mesaj alanlarını doldurun' });
                        return;
                      }

                      // Onay popup'ı yok - direk gönder
                      setSendingNotification(true);
                      setNotificationResult(null);
                      try {
                        await axios.post(`${API}/notifications/send`, notificationForm, axiosConfig);
                        const resultMessage = notificationForm.user_id 
                          ? '✅ 1 kullanıcıya gönderildi' 
                          : `✅ ${users.length} kullanıcıya gönderildi`;
                        setNotificationResult({ success: true, message: resultMessage });
                        
                        // Reset form
                        setNotificationForm({
                          title: '',
                          message: '',
                          type: 'info',
                          user_id: null
                        });
                      } catch (err) {
                        setNotificationResult({ success: false, message: '❌ Gönderilemedi: ' + (err.response?.data?.detail || err.message) });
                      } finally {
                        setSendingNotification(false);
                      }
                    }}
                    disabled={sendingNotification}
                    className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 py-4 rounded-lg font-bold text-lg transition-colors"
                  >
                    {sendingNotification ? '⏳ Gönderiliyor...' : '📤 Bildirim Gönder'}
                  </button>
                  
                  {/* Sonuç mesajı - butonun altında */}
                  {notificationResult && (
                    <div className={`mt-3 p-3 rounded-lg text-center font-medium ${
                      notificationResult.success 
                        ? 'bg-green-900/50 text-green-400 border border-green-700' 
                        : 'bg-red-900/50 text-red-400 border border-red-700'
                    }`}>
                      {notificationResult.message}
                    </div>
                  )}
                </div>
              </div>

              {/* Preview */}
              {notificationForm.title && notificationForm.message && (
                <div className="bg-gray-800 rounded-lg p-6">
                  <h3 className="text-xl font-bold mb-4">👁️ Önizleme</h3>
                  <div className={`bg-gray-700 rounded-lg p-4 border-l-4 ${
                    notificationForm.type === 'warning' ? 'border-yellow-500' :
                    notificationForm.type === 'danger' ? 'border-red-500' :
                    notificationForm.type === 'success' ? 'border-green-500' :
                    'border-blue-500'
                  }`}>
                    <div className="flex items-start gap-3">
                      <div className="text-3xl">
                        {notificationForm.type === 'warning' ? '⚠️' :
                         notificationForm.type === 'danger' ? '🚨' :
                         notificationForm.type === 'success' ? '✅' : 'ℹ️'}
                      </div>
                      <div className="flex-1">
                        <h3 className="font-bold text-lg">{notificationForm.title}</h3>
                        <p className="text-gray-300 mt-1 whitespace-pre-wrap">{notificationForm.message}</p>
                        <p className="text-gray-500 text-sm mt-2">Az önce</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Email Tab */}
          {activeTab === 'email' && (
            <div className="space-y-6">
              <div className="bg-gray-800 rounded-lg p-6">
                <h2 className="text-2xl font-bold mb-6 flex items-center gap-2">
                  📧 E-posta Gönder
                </h2>
                
                {/* Otomatik E-posta Toggle */}
                <div className="bg-gray-700 rounded-lg p-4 mb-6 flex items-center justify-between">
                  <div>
                    <h3 className="text-white font-semibold">Otomatik Hoş Geldin E-postası</h3>
                    <p className="text-gray-400 text-sm">Yeni üye kaydolduğunda otomatik e-posta gönder</p>
                  </div>
                  <button
                    onClick={toggleAutoWelcomeEmail}
                    className={`relative w-14 h-7 rounded-full transition-colors ${
                      autoWelcomeEmailEnabled ? 'bg-green-500' : 'bg-gray-500'
                    }`}
                  >
                    <span
                      className={`absolute top-1 w-5 h-5 bg-white rounded-full transition-transform ${
                        autoWelcomeEmailEnabled ? 'right-1' : 'left-1'
                      }`}
                    />
                  </button>
                </div>
                
                <div className="space-y-4">
                  <div>
                    <label className="block text-gray-300 mb-2">Konu</label>
                    <input
                      type="text"
                      value={emailForm?.subject || ''}
                      onChange={(e) => setEmailForm({ ...emailForm, subject: e.target.value })}
                      placeholder="E-posta konusu"
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3 text-white"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-300 mb-2">Mesaj</label>
                    <textarea
                      value={emailForm?.message || ''}
                      onChange={(e) => setEmailForm({ ...emailForm, message: e.target.value })}
                      placeholder="E-posta mesajı"
                      rows={8}
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3 text-white"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-300 mb-2">Hedef Kullanıcı</label>
                    <select
                      value={emailForm?.selectedUser || 'all'}
                      onChange={(e) => setEmailForm({ 
                        ...emailForm, 
                        selectedUser: e.target.value
                      })}
                      className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3 text-white"
                    >
                      <option value="all">📢 Tüm Kullanıcılara Gönder</option>
                      {users.map(user => (
                        <option key={user.id} value={user.id}>
                          {user.email} - {user.full_name || 'İsimsiz'}
                        </option>
                      ))}
                    </select>
                  </div>

                  <button
                    onClick={async () => {
                      if (!emailForm?.subject || !emailForm?.message) {
                        setEmailResult({ success: false, message: '❌ Lütfen konu ve mesaj alanlarını doldurun' });
                        return;
                      }

                      setSendingEmail(true);
                      setEmailResult(null);
                      try {
                        const user_ids = emailForm.selectedUser === 'all' ? [] : [emailForm.selectedUser];
                        const response = await axios.post(`${API}/admin/send-email`, {
                          user_ids: user_ids,
                          subject: emailForm.subject,
                          message: emailForm.message
                        }, axiosConfig);
                        
                        const data = response.data;
                        const resultMessage = data.failed > 0 
                          ? `✅ ${data.sent_to} başarılı, ❌ ${data.failed} başarısız`
                          : `✅ ${data.sent_to} kullanıcıya e-posta gönderildi`;
                        setEmailResult({ success: true, message: resultMessage });
                        
                        // Reset form
                        setEmailForm({
                          subject: '',
                          message: '',
                          selectedUser: 'all'
                        });
                      } catch (err) {
                        setEmailResult({ success: false, message: '❌ Gönderilemedi: ' + (err.response?.data?.detail || err.message) });
                      } finally {
                        setSendingEmail(false);
                      }
                    }}
                    disabled={sendingEmail}
                    className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 py-4 rounded-lg font-bold text-lg transition-colors"
                  >
                    {sendingEmail ? '⏳ Gönderiliyor...' : '📤 E-posta Gönder'}
                  </button>
                  
                  {/* Sonuç mesajı */}
                  {emailResult && (
                    <div className={`mt-3 p-3 rounded-lg text-center font-medium ${
                      emailResult.success 
                        ? 'bg-green-900/50 text-green-400 border border-green-700' 
                        : 'bg-red-900/50 text-red-400 border border-red-700'
                    }`}>
                      {emailResult.message}
                    </div>
                  )}
                </div>
              </div>

              {/* Bilgilendirme */}
              <div className="bg-gray-800 rounded-lg p-6">
                <h3 className="text-xl font-bold mb-4">ℹ️ E-posta Hakkında</h3>
                <div className="space-y-3 text-gray-300">
                  <p>• <strong>Tüm kullanıcılara gönderim:</strong> Aktif tüm kullanıcılara toplu e-posta gönderir.</p>
                  <p>• <strong>Tek kullanıcıya gönderim:</strong> Seçilen kullanıcıya kişiselleştirilmiş e-posta gönderir.</p>
                  <p>• <strong>Otomatik hoş geldin:</strong> Yeni üye kaydolduğunda otomatik olarak hoş geldin e-postası gönderilir.</p>
                  <p className="text-yellow-400">⚠️ Toplu gönderim zaman alabilir. Sayfa açık kalmalıdır.</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* User Detail Modal */}
      {selectedUser && (
        <div className="fixed inset-0 bg-black/75 flex items-center justify-center z-50" onClick={() => setSelectedUser(null)}>
          <div className="bg-gray-800 rounded-lg p-3 sm:p-6 max-w-2xl w-full mx-4" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-xl font-bold mb-4">Kullanıcı Detay</h3>
            <div className="space-y-3">
              <InfoRow label="ID" value={selectedUser.id} />
              <InfoRow label="Email" value={selectedUser.email} />
              <InfoRow label="Ad Soyad" value={selectedUser.full_name || '-'} />
              <InfoRow label="Bakiye" value={`${selectedUser.balance.toFixed(2)} TL`} />
              <InfoRow label="Kayıt Tarihi" value={new Date(selectedUser.created_at).toLocaleString('tr-TR')} />
              <InfoRow label="Admin" value={selectedUser.is_admin ? 'Evet' : 'Hayır'} />
            </div>
            <button
              onClick={() => setSelectedUser(null)}
              className="mt-4 w-full py-2 bg-gray-700 hover:bg-gray-600 rounded"
            >
              Kapat
            </button>
          </div>
        </div>
      )}
      
      {/* Balance Adjustment Modal */}
      {showBalanceModal && (
        <div className="fixed inset-0 bg-black/75 flex items-center justify-center z-50" onClick={() => setShowBalanceModal(false)}>
          <div className="bg-gray-800 rounded-lg p-3 sm:p-6 max-w-md w-full mx-4" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-xl font-bold mb-4">Bakiye Ayarla</h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-gray-300 mb-2 text-sm">Miktar (TL)</label>
                <input
                  type="number"
                  step="0.01"
                  value={balanceAdjustment.amount}
                  onChange={(e) => setBalanceAdjustment({...balanceAdjustment, amount: e.target.value})}
                  placeholder="Örn: 1000 (eklemek için +) veya -500 (çıkarmak için)"
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                />
                <div className="text-xs text-gray-400 mt-1">
                  Pozitif sayı: bakiye ekler | Negatif sayı: bakiyeden çıkarır
                </div>
              </div>
              
              <div>
                <label className="block text-gray-300 mb-2 text-sm">Açıklama (Opsiyonel)</label>
                <input
                  type="text"
                  value={balanceAdjustment.reason}
                  onChange={(e) => setBalanceAdjustment({...balanceAdjustment, reason: e.target.value})}
                  placeholder="Bakiye ayarlama sebebi"
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                />
              </div>
              
              <div className="flex gap-3 mt-6">
                <button 
                  onClick={handleAdjustBalance} 
                  disabled={loading}
                  className="flex-1 py-2 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 rounded font-semibold"
                >
                  {loading ? 'Güncelleniyor...' : 'BAKİYE GÜNCELLE'}
                </button>
                <button 
                  onClick={() => setShowBalanceModal(false)} 
                  className="flex-1 py-2 bg-gray-700 hover:bg-gray-600 rounded"
                >
                  İptal
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Asset Modal */}
      {showEditAssetModal && editingAsset && (
        <EditAssetModal
          asset={editingAsset}
          onClose={() => setShowEditAssetModal(false)}
          onUpdate={handleUpdateAsset}
          onChange={setEditingAsset}
          showAlert={showAlert}
          fetchAssets={fetchAssets}
        />
      )}

      {/* User Detail Modal */}
      {showUserDetailModal && userDetailData && (
        <UserDetailManagement
          user={userDetailData}
          onClose={handleCloseUserDetail}
          onRefresh={async () => {
            // Kullanıcı detayını yeniden yükle
            if (userDetailData?.id) {
              try {
                const userResponse = await axios.get(`${API}/admin/users/${userDetailData.id}`, axiosConfig);
                if (userResponse.data) {
                  setUserDetailData(userResponse.data);
                }
              } catch (err) {
                console.error('Error refreshing user detail:', err);
              }
            }
            fetchUsers();
            fetchDashboardStats();
          }}
        />
      )}

      {/* Yeni Kullanıcı Oluşturma Modal - AdminPanelNew içinde */}
      {showCreateUserModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{backgroundColor: 'rgba(0,0,0,0.7)'}}>
          <div className="bg-gray-800 rounded-xl w-full max-w-md p-6 shadow-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-white">Yeni Kullanıcı Oluştur</h3>
              <button onClick={() => setShowCreateUserModal(false)} className="text-gray-400 hover:text-white text-2xl">&times;</button>
            </div>
            
            <div className="space-y-4">
              <div>
                <label className="block text-gray-400 text-sm mb-1">Email *</label>
                <input
                  type="email"
                  placeholder="ornek@email.com"
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                  value={createUserForm.email}
                  onChange={(e) => setCreateUserForm({...createUserForm, email: e.target.value})}
                />
              </div>
              
              <div>
                <label className="block text-gray-400 text-sm mb-1">Şifre *</label>
                <input
                  type="password"
                  placeholder="En az 6 karakter"
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                  value={createUserForm.password}
                  onChange={(e) => setCreateUserForm({...createUserForm, password: e.target.value})}
                />
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-gray-400 text-sm mb-1">Ad</label>
                  <input
                    type="text"
                    className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                    value={createUserForm.name}
                    onChange={(e) => setCreateUserForm({...createUserForm, name: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-gray-400 text-sm mb-1">Soyad</label>
                  <input
                    type="text"
                    className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                    value={createUserForm.surname}
                    onChange={(e) => setCreateUserForm({...createUserForm, surname: e.target.value})}
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-gray-400 text-sm mb-1">TC Kimlik No</label>
                <input
                  type="text"
                  maxLength={11}
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                  value={createUserForm.tc_no}
                  onChange={(e) => setCreateUserForm({...createUserForm, tc_no: e.target.value})}
                />
              </div>
              
              <div>
                <label className="block text-gray-400 text-sm mb-1">Telefon</label>
                <input
                  type="text"
                  placeholder="5XX XXX XXXX"
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                  value={createUserForm.phone}
                  onChange={(e) => setCreateUserForm({...createUserForm, phone: e.target.value})}
                />
              </div>
              
              <div>
                <label className="block text-gray-400 text-sm mb-1">Hesap Tipi</label>
                <select
                  className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                  value={createUserForm.account_type}
                  onChange={(e) => setCreateUserForm({...createUserForm, account_type: e.target.value})}
                >
                  <option value="STANDART">STANDART</option>
                  <option value="VIP">VIP</option>
                  <option value="PREMIUM">PREMIUM</option>
                </select>
              </div>
              
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-gray-400 text-sm mb-1">Başlangıç Bakiyesi ($)</label>
                  <input
                    type="number"
                    min="0"
                    className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                    value={createUserForm.balance}
                    onChange={(e) => setCreateUserForm({...createUserForm, balance: parseFloat(e.target.value) || 0})}
                  />
                </div>
                <div>
                  <label className="block text-gray-400 text-sm mb-1">Kredi ($)</label>
                  <input
                    type="number"
                    min="0"
                    className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
                    value={createUserForm.credit}
                    onChange={(e) => setCreateUserForm({...createUserForm, credit: parseFloat(e.target.value) || 0})}
                  />
                </div>
              </div>
              
              <div className="flex gap-3 pt-2">
                <button
                  onClick={() => setShowCreateUserModal(false)}
                  className="flex-1 py-2 bg-gray-600 hover:bg-gray-500 rounded text-white"
                >
                  İptal
                </button>
                <button
                  onClick={handleCreateUser}
                  className="flex-1 py-2 bg-green-600 hover:bg-green-700 rounded text-white font-medium"
                >
                  Kullanıcı Oluştur
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function StatCard({ title, value, color = 'text-white' }) {
  return (
    <div className="bg-gray-700 px-3 py-2 rounded">
      <div className="text-xs text-gray-400 uppercase">{title}</div>
      <div className={`font-bold text-sm ${color}`}>{value}</div>
    </div>
  );
}

function TabButton({ children, active, onClick, icon: Icon }) {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-3 py-2 rounded mb-1 transition-colors flex items-center gap-2 text-sm ${
        active
          ? 'bg-purple-600 text-white'
          : 'text-gray-300 hover:bg-gray-700'
      }`}
    >
      {Icon && <Icon size={18} />}
      <span>{children}</span>
    </button>
  );
}

function StatusBadge({ status }) {
  const colors = {
    PENDING: 'bg-yellow-900 text-yellow-300',
    APPROVED: 'bg-green-900 text-green-300',
    REJECTED: 'bg-red-900 text-red-300'
  };
  
  return (
    <span className={`px-2 py-1 rounded text-xs ${colors[status] || colors.PENDING}`}>
      {status}
    </span>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="flex justify-between py-2 border-b border-gray-700">
      <span className="text-gray-400">{label}:</span>
      <span className="font-semibold">{value}</span>
    </div>
  );
}

// Edit Asset Modal Component
function EditAssetModal({ asset, onClose, onUpdate, onChange, showAlert, fetchAssets }) {
  if (!asset) return null;

  return (
    <div className="fixed inset-0 bg-black/75 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-gray-800 rounded-lg p-3 sm:p-6 max-w-lg w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-2xl font-bold mb-4"> Varlık Düzenle</h3>
        
        <div className="space-y-4">
          {/* Sembol */}
          <div>
            <label className="block text-gray-300 mb-2 text-sm font-semibold">
              🏷️ Sembol
            </label>
            <input
              type="text"
              value={asset.symbol || ''}
              onChange={(e) => onChange({ ...asset, symbol: e.target.value.toUpperCase() })}
              placeholder="Örn: GARAN, AAPL, BTC"
              className="w-full bg-gray-700 border border-blue-500 rounded px-4 py-3 text-xl font-bold"
            />
          </div>

          {/* Varlık İsmi */}
          <div>
            <label className="block text-gray-300 mb-2 text-sm font-semibold">
              📝 Varlık İsmi
            </label>
            <input
              type="text"
              value={asset.name || ''}
              onChange={(e) => onChange({ ...asset, name: e.target.value })}
              placeholder="Örn: Garanti Bankası A.Ş."
              className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
            />
          </div>

          {/* Kategori */}
          <div>
            <label className="block text-gray-300 mb-2 text-sm font-semibold">
              📁 Kategori
            </label>
            <select
              value={asset.category || ''}
              onChange={(e) => onChange({ ...asset, category: e.target.value })}
              className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
            >
              <option value="BIST_100">BIST 100</option>
              <option value="ABD_NASDAQ">ABD NASDAQ</option>
              <option value="US_STOCKS">ABD Hisseleri</option>
              <option value="KRIPTO">Kripto</option>
              <option value="EMTIA">Emtia</option>
              <option value="DOVIZ">Döviz</option>
              <option value="ENDEKSLER">Endeksler</option>
              <option value="VIOP">VİOP</option>
            </select>
          </div>

          <div>
            <label className="block text-gray-300 mb-2 text-sm font-semibold">
              Fiyat (TL)
            </label>
            <input
              type="number"
              step="0.01"
              value={asset.current_price}
              onChange={(e) => onChange({ ...asset, current_price: e.target.value })}
              className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3 text-lg font-bold"
            />
          </div>

          <div>
            <label className="block text-gray-300 mb-2 text-sm font-semibold">
              Değişim Yüzdesi (%)
            </label>
            <input
              type="number"
              step="0.01"
              value={asset.change_percent}
              onChange={(e) => onChange({ ...asset, change_percent: e.target.value })}
              className="w-full bg-gray-700 border border-gray-600 rounded px-4 py-3"
            />
          </div>

          {/* Faz 2 Paket 3 — Gizli Kaldıraç edit alanı KALDIRILDI.
              Kaldıraç yalnız /admin/leverage-groups üzerinden değiştirilir. */}

          {/* Hızlı Değişim Butonları */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
            <button
              onClick={() => {
                const currentPrice = parseFloat(asset.current_price);
                const newPrice = currentPrice * 1.05;
                onChange({ ...asset, current_price: newPrice.toFixed(2), change_percent: '5.00' });
              }}
              className="py-2 bg-green-600 hover:bg-green-700 rounded text-xs"
            >
              +5%
            </button>
            <button
              onClick={() => {
                const currentPrice = parseFloat(asset.current_price);
                const newPrice = currentPrice * 1.10;
                onChange({ ...asset, current_price: newPrice.toFixed(2), change_percent: '10.00' });
              }}
              className="py-2 bg-green-600 hover:bg-green-700 rounded text-xs"
            >
              +10%
            </button>
            <button
              onClick={() => {
                const currentPrice = parseFloat(asset.current_price);
                const newPrice = currentPrice * 0.95;
                onChange({ ...asset, current_price: newPrice.toFixed(2), change_percent: '-5.00' });
              }}
              className="py-2 bg-red-600 hover:bg-red-700 rounded text-xs"
            >
              -5%
            </button>
            <button
              onClick={() => {
                const currentPrice = parseFloat(asset.current_price);
                const newPrice = currentPrice * 0.90;
                onChange({ ...asset, current_price: newPrice.toFixed(2), change_percent: '-10.00' });
              }}
              className="py-2 bg-red-600 hover:bg-red-700 rounded text-xs"
            >
              -10%
            </button>
          </div>

          {/* Orijinal Fiyata Döndür */}
          <button
            onClick={async () => {
              try {
                showAlert('Orijinal fiyat alınıyor...', 'info');
                const response = await axios.post(`${API}/assets/${asset.id}/reset-price`, {}, {
                  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                  timeout: 30000  // 30 saniye timeout
                });
                console.log('Reset price response:', response.data);
                const msg = `✅ ${response.data.message}\n\n📊 Orijinal Fiyat: ₺${response.data.original_price?.toFixed(2) || 'N/A'}\n📈 Değişim: ${response.data.change_percent?.toFixed(2) || 0}%`;
                showAlert(msg, 'success');
                // Modalı kapat ve asset listesini güncelle (sayfayı yenileme)
                onClose();
                // fetchAssets varsa çağır
                if (typeof fetchAssets === 'function') {
                  fetchAssets();
                }
              } catch (error) {
                console.error('Reset price error:', error);
                const errMsg = error.response?.data?.detail || error.message || 'Fiyat sıfırlanamadı - bağlantı hatası';
                showAlert('❌ Hata: ' + errMsg, 'error');
              }
            }}
            className="w-full py-2 bg-yellow-600 hover:bg-yellow-700 rounded text-sm font-semibold mb-4"
          >
            🔄 Orijinal Fiyata Döndür (API)
          </button>

          <div className="flex gap-3 mt-2">
            <button
              onClick={onUpdate}
              className="flex-1 py-3 bg-purple-600 hover:bg-purple-700 rounded font-semibold"
            >
              ✅ Güncelle
            </button>
            <button
              onClick={onClose}
              className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 rounded"
            >
              İptal
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPanelNew;
